import { useState, useEffect, useRef, useCallback } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDJsGMLD8D8qsKGZ0kMaL-2q_pPNHQfp-Q",
  authDomain: "soushun-menu-system.firebaseapp.com",
  projectId: "soushun-menu-system",
  storageBucket: "soushun-menu-system.firebasestorage.app",
  messagingSenderId: "736442004711",
  appId: "1:736442004711:web:fef02e407253dcbffe9e42",
};
const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

const CLOUDINARY_CLOUD_NAME = "dchfnr8b8";
const CLOUDINARY_UPLOAD_PRESET = "ml_default";

const POINT_LIMIT = 100;
const ADMIN_ID = "ss87kimama";
const ADMIN_PASSWORD = "admin1234";
const SEASON_LIST = ["春","夏","秋","冬"];
const SEASON_DATES = {春:{start:"3/1",end:"5/31"},夏:{start:"6/1",end:"8/31"},秋:{start:"9/1",end:"11/30"},冬:{start:"12/1",end:"2/末"}};
const SEASON_EMOJI = {春:"🌸",夏:"🌻",秋:"🍂",冬:"❄️"};
const SEASON_COLOR = {春:"#fce7f3",夏:"#d1fae5",秋:"#fef3c7",冬:"#dbeafe"};

// ─── 季節テーマ定義 ───────────────────────────────────────────────────────────
const SEASON_THEME = {
  春: {
    bg:          "linear-gradient(160deg,#fff8f8 0%,#fff0f5 40%,#fdf6ee 100%)",
    headerBg:    "linear-gradient(135deg,#7b2d44,#b05070)",
    headerText:  "#fff",
    accent:      "#9b3a58",
    accentLight: "#fce4ec",
    accentBorder:"#f0a8bc",
    cardBg:      "#fffafb",
    cardBorder:  "#f5c6d4",
    cardSelected:"#fce4ec",
    cardBorderSelected:"#c2637a",
    catLabel:    "#7b2d44",
    catBorder:   "linear-gradient(90deg,#c2637a,transparent)",
    ptColor:     "#9b3a58",
    ptBg:        "#fce4ec",
    ptBorder:    "#f0a8bc",
    tabActive:   "#9b3a58",
    tabActiveBg: "#fce4ec",
    saveBg:      "#9b3a58",
    motif:       "🌸",
    motifAlt:    "✿",
    tagline:     "春の彩りをお楽しみください",
    noImgBg:     "linear-gradient(135deg,#fce4ec,#fff0f5)",
    noImgText:   "#d4839a",
  },
  夏: {
    bg:          "linear-gradient(160deg,#f0fbff 0%,#e8f7f0 50%,#fffde8 100%)",
    headerBg:    "linear-gradient(135deg,#0d6b5e,#1a9980)",
    headerText:  "#fff",
    accent:      "#0d6b5e",
    accentLight: "#d4f0ea",
    accentBorder:"#7ecfc0",
    cardBg:      "#f8fefc",
    cardBorder:  "#b2e2d8",
    cardSelected:"#d4f0ea",
    cardBorderSelected:"#1a9980",
    catLabel:    "#0d6b5e",
    catBorder:   "linear-gradient(90deg,#1a9980,transparent)",
    ptColor:     "#0d6b5e",
    ptBg:        "#d4f0ea",
    ptBorder:    "#7ecfc0",
    tabActive:   "#0d6b5e",
    tabActiveBg: "#d4f0ea",
    saveBg:      "#0d6b5e",
    motif:       "🌊",
    motifAlt:    "〜",
    tagline:     "夏の恵みをご堪能ください",
    noImgBg:     "linear-gradient(135deg,#d4f0ea,#e8f7f0)",
    noImgText:   "#5ab8aa",
  },
  秋: {
    bg:          "linear-gradient(160deg,#fdf6ee 0%,#fef0e0 50%,#fdf8f2 100%)",
    headerBg:    "linear-gradient(135deg,#6b3a1f,#a0581e)",
    headerText:  "#fff",
    accent:      "#7a3d1a",
    accentLight: "#fde8cc",
    accentBorder:"#e8b07a",
    cardBg:      "#fffcf8",
    cardBorder:  "#e8cba8",
    cardSelected:"#fde8cc",
    cardBorderSelected:"#a0581e",
    catLabel:    "#7a3d1a",
    catBorder:   "linear-gradient(90deg,#a0581e,transparent)",
    ptColor:     "#7a3d1a",
    ptBg:        "#fde8cc",
    ptBorder:    "#e8b07a",
    tabActive:   "#7a3d1a",
    tabActiveBg: "#fde8cc",
    saveBg:      "#7a3d1a",
    motif:       "🍂",
    motifAlt:    "⌾",
    tagline:     "実りの秋の味覚をどうぞ",
    noImgBg:     "linear-gradient(135deg,#fde8cc,#fef0e0)",
    noImgText:   "#c8855a",
  },
  冬: {
    bg:          "linear-gradient(160deg,#f2f6ff 0%,#eaf0fb 50%,#f8f8ff 100%)",
    headerBg:    "linear-gradient(135deg,#1a2b5e,#2e4a8e)",
    headerText:  "#fff",
    accent:      "#1e3575",
    accentLight: "#dce6f8",
    accentBorder:"#90aae0",
    cardBg:      "#f8faff",
    cardBorder:  "#b8cce8",
    cardSelected:"#dce6f8",
    cardBorderSelected:"#2e4a8e",
    catLabel:    "#1a2b5e",
    catBorder:   "linear-gradient(90deg,#2e4a8e,transparent)",
    ptColor:     "#1a2b5e",
    ptBg:        "#dce6f8",
    ptBorder:    "#90aae0",
    tabActive:   "#1a2b5e",
    tabActiveBg: "#dce6f8",
    saveBg:      "#1a2b5e",
    motif:       "❄️",
    motifAlt:    "✦",
    tagline:     "冬の温もりをお届けします",
    noImgBg:     "linear-gradient(135deg,#dce6f8,#eaf0fb)",
    noImgText:   "#7090c0",
  },
};

// 汎用テーマ（季節未確定時のフォールバック）
const THEME_DEFAULT = SEASON_THEME["春"];

// ─── デフォルトデータ ─────────────────────────────────────────────────────────
const DEFAULT_CATEGORIES = [
  {id:"cat1",name:"前菜",order:1},
  {id:"cat2",name:"スープ",order:2},
  {id:"cat3",name:"肉料理",order:3},
];

const DEFAULT_MENUS = [
  {id:1,name:"桜えびのかき揚げ",order:1,catOrder:1,categoryId:"cat1",points:15,season:"春",allergens:"えび・小麦",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:2,name:"菜の花のおひたし",order:2,catOrder:1,categoryId:"cat1",points:8,season:"春",allergens:"なし",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:3,name:"春キャベツのサラダ",order:3,catOrder:1,categoryId:"cat1",points:10,season:"春",allergens:"なし",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:4,name:"たけのこご飯",order:4,catOrder:999,categoryId:null,points:20,season:"春",allergens:"なし",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:5,name:"豆腐と春野菜の味噌汁",order:1,catOrder:2,categoryId:"cat2",points:8,season:"春",allergens:"大豆",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:6,name:"アスパラの肉巻き",order:1,catOrder:3,categoryId:"cat3",points:18,season:"春",allergens:"豚肉",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:7,name:"新玉ねぎのスープ",order:2,catOrder:2,categoryId:"cat2",points:10,season:"春",allergens:"なし",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:8,name:"春野菜のパスタ",order:5,catOrder:999,categoryId:null,points:22,season:"春",allergens:"小麦・卵",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:9,name:"いちごのパンナコッタ",order:6,catOrder:999,categoryId:null,points:12,season:"春",allergens:"乳",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:10,name:"桜餅",order:7,catOrder:999,categoryId:null,points:10,season:"春",allergens:"小麦・乳",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:11,name:"春巻き（春野菜入り）",order:2,catOrder:3,categoryId:"cat3",points:16,season:"春",allergens:"小麦",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:12,name:"ふきのとうの天ぷら",order:8,catOrder:999,categoryId:null,points:14,season:"春",allergens:"小麦",img:"",start:"3/1",end:"5/31",note:"",hidden:false},
  {id:13,name:"冷やし中華",order:1,catOrder:999,categoryId:null,points:22,season:"夏",allergens:"小麦・卵",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:14,name:"ゴーヤチャンプルー",order:1,catOrder:3,categoryId:"cat3",points:18,season:"夏",allergens:"卵・大豆",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:15,name:"そうめん",order:2,catOrder:999,categoryId:null,points:15,season:"夏",allergens:"小麦",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:16,name:"トマトのカプレーゼ",order:1,catOrder:1,categoryId:"cat1",points:12,season:"夏",allergens:"乳",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:17,name:"枝豆の塩ゆで",order:2,catOrder:1,categoryId:"cat1",points:8,season:"夏",allergens:"大豆",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:18,name:"冷製コーンスープ",order:1,catOrder:2,categoryId:"cat2",points:12,season:"夏",allergens:"乳",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:19,name:"うなぎの蒲焼き",order:2,catOrder:3,categoryId:"cat3",points:30,season:"夏",allergens:"なし",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:20,name:"スイカのデザート",order:3,catOrder:999,categoryId:null,points:8,season:"夏",allergens:"なし",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:21,name:"焼きとうもろこし",order:4,catOrder:999,categoryId:null,points:10,season:"夏",allergens:"なし",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:22,name:"かき氷（抹茶）",order:5,catOrder:999,categoryId:null,points:10,season:"夏",allergens:"乳",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:23,name:"夏野菜カレー",order:3,catOrder:3,categoryId:"cat3",points:25,season:"夏",allergens:"小麦・乳",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:24,name:"冷製カッペリーニ",order:6,catOrder:999,categoryId:null,points:20,season:"夏",allergens:"小麦",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:25,name:"モロヘイヤのスープ",order:2,catOrder:2,categoryId:"cat2",points:10,season:"夏",allergens:"なし",img:"",start:"6/1",end:"8/31",note:"",hidden:false},
  {id:26,name:"松茸のお吸い物",order:1,catOrder:2,categoryId:"cat2",points:25,season:"秋",allergens:"なし",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:27,name:"栗ご飯",order:1,catOrder:999,categoryId:null,points:20,season:"秋",allergens:"なし",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:28,name:"さんまの塩焼き",order:1,catOrder:3,categoryId:"cat3",points:18,season:"秋",allergens:"なし",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:29,name:"きのこの炊き込みご飯",order:2,catOrder:999,categoryId:null,points:18,season:"秋",allergens:"なし",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:30,name:"かぼちゃのスープ",order:2,catOrder:2,categoryId:"cat2",points:12,season:"秋",allergens:"乳",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:31,name:"里芋の煮っころがし",order:3,catOrder:999,categoryId:null,points:12,season:"秋",allergens:"なし",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:32,name:"柿とクリームチーズのサラダ",order:1,catOrder:1,categoryId:"cat1",points:14,season:"秋",allergens:"乳",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:33,name:"秋鮭のムニエル",order:2,catOrder:3,categoryId:"cat3",points:22,season:"秋",allergens:"乳・小麦",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:34,name:"さつまいものモンブラン",order:4,catOrder:999,categoryId:null,points:15,season:"秋",allergens:"乳・卵",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:35,name:"きのこのリゾット",order:3,catOrder:3,categoryId:"cat3",points:22,season:"秋",allergens:"乳",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:36,name:"ぶどうのゼリー",order:5,catOrder:999,categoryId:null,points:10,season:"秋",allergens:"なし",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:37,name:"れんこんのきんぴら",order:6,catOrder:999,categoryId:null,points:10,season:"秋",allergens:"ごま",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:38,name:"牛肉と秋野菜のすき焼き",order:4,catOrder:3,categoryId:"cat3",points:30,season:"秋",allergens:"卵・小麦",img:"",start:"9/1",end:"11/30",note:"",hidden:false},
  {id:39,name:"おでん盛り合わせ",order:1,catOrder:999,categoryId:null,points:22,season:"冬",allergens:"小麦・卵",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
  {id:40,name:"鍋料理（豆乳鍋）",order:1,catOrder:3,categoryId:"cat3",points:28,season:"冬",allergens:"大豆・乳",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
  {id:41,name:"ぶりの照り焼き",order:2,catOrder:3,categoryId:"cat3",points:22,season:"冬",allergens:"なし",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
  {id:42,name:"牡蠣のグラタン",order:3,catOrder:3,categoryId:"cat3",points:25,season:"冬",allergens:"乳・小麦・卵",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
  {id:43,name:"根菜の豚汁",order:1,catOrder:2,categoryId:"cat2",points:15,season:"冬",allergens:"豚肉",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
  {id:44,name:"白菜と豚の重ね蒸し",order:4,catOrder:3,categoryId:"cat3",points:20,season:"冬",allergens:"豚肉",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
  {id:45,name:"ほうとう",order:2,catOrder:999,categoryId:null,points:22,season:"冬",allergens:"小麦",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
  {id:46,name:"クリームシチュー",order:5,catOrder:3,categoryId:"cat3",points:22,season:"冬",allergens:"乳・小麦",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
  {id:47,name:"いちごのショートケーキ",order:3,catOrder:999,categoryId:null,points:15,season:"冬",allergens:"乳・卵・小麦",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
  {id:48,name:"お雑煮",order:4,catOrder:999,categoryId:null,points:18,season:"冬",allergens:"小麦",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
  {id:49,name:"柚子ゼリー",order:5,catOrder:999,categoryId:null,points:10,season:"冬",allergens:"なし",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
  {id:50,name:"かに玉あんかけ",order:2,catOrder:2,categoryId:"cat2",points:25,season:"冬",allergens:"卵・かに",img:"",start:"12/1",end:"2/末",note:"",hidden:false},
];

// ─── ユーティリティ関数 ───────────────────────────────────────────────────────
function assignNos(list){
  const cnt={};
  return list.map(m=>{ cnt[m.season]=(cnt[m.season]||0)+1; return {...m,no:String(cnt[m.season]).padStart(2,"0")}; });
}
function sortedMenus(list){
  return [...list].sort((a,b)=>{
    const si=SEASON_LIST.indexOf(a.season)-SEASON_LIST.indexOf(b.season);
    if(si!==0) return si;
    const ci=(a.catOrder||999)-(b.catOrder||999);
    if(ci!==0) return ci;
    return (a.order||0)-(b.order||0);
  });
}
function withNos(list){ return assignNos(sortedMenus(list)); }
function getSeason(d){ if(!d)return null; const m=new Date(d).getMonth()+1; if(m>=3&&m<=5)return"春"; if(m>=6&&m<=8)return"夏"; if(m>=9&&m<=11)return"秋"; return"冬"; }
function isPast(d){ if(!d)return false; const t=new Date(); t.setHours(0,0,0,0); return new Date(d)<t; }
function fmtDt(iso){ if(!iso)return"-"; const d=new Date(iso); return`${d.getFullYear()}/${String(d.getMonth()+1).padStart(2,"0")}/${String(d.getDate()).padStart(2,"0")} ${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`; }
function fmtDate(isoOrStr){
  if(!isoOrStr) return "-";
  const m=isoOrStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if(m) return `${m[1]}/${m[2]}/${m[3]}`;
  return isoOrStr;
}

// 利用日が対象期間外かチェック（start/endは"M/D"形式, dateはyyyy-mm-dd）
function isOutOfPeriod(menu, date){
  if(!date||!menu.start||!menu.end) return false;
  const d = new Date(date);
  const md = (d.getMonth()+1)*100 + d.getDate();
  function parseMD(str){
    const p = String(str).replace("末","28").split("/");
    if(p.length<2) return null;
    return parseInt(p[0])*100 + parseInt(p[1]);
  }
  const s = parseMD(menu.start);
  const e = parseMD(menu.end);
  if(s===null||e===null) return false;
  if(s<=e) return md<s || md>e;
  return md<s && md>e;
}


// ─── ストレージ操作（タイムアウト付き） ──────────────────────────────────────
async function sget(k){
  // Firestore（本番環境）
  try{
    const snap=await getDoc(doc(db,"menuSystem",k));
    if(snap.exists()) return snap.data().value;
  }catch{}
  // フォールバック：localStorage
  try{
    const v=localStorage.getItem("menu_sys__"+k);
    if(v!==null) return JSON.parse(v);
  }catch{}
  // フォールバック：window.storage（Artifact環境）
  try{
    if(window.storage){
      const r=await Promise.race([
        window.storage.get(k),
        new Promise((_,rej)=>setTimeout(()=>rej(new Error('timeout')),3000))
      ]);
      return r?JSON.parse(r.value):null;
    }
  }catch{}
  return null;
}
async function sset(k,v){
  // Firestore（本番環境）- メインストレージ
  try{
    await setDoc(doc(db,"menuSystem",k),{value:v});
    return; // Firestore成功したらlocalStorageには保存しない
  }catch{}
  // フォールバック：localStorage（Firestore失敗時のみ）
  try{
    localStorage.setItem("menu_sys__"+k, JSON.stringify(v));
  }catch{}
  // フォールバック：window.storage（Artifact環境）
  try{
    if(window.storage){
      await Promise.race([
        window.storage.set(k,JSON.stringify(v)),
        new Promise((_,rej)=>setTimeout(()=>rej(new Error('timeout')),3000))
      ]);
    }
  }catch{}
}

// ─── フォント読み込み（link要素をheadに挿入） ────────────────────────────────
function FontStyle(){
  useEffect(()=>{
    // viewportにuser-scalable=noを設定（スマホズーム防止）
    let vp=document.querySelector("meta[name='viewport']");
    if(!vp){ vp=document.createElement("meta"); vp.name="viewport"; document.head.appendChild(vp); }
    vp.content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
    // Google Fonts
    if(!document.getElementById('wa-font-link')){
      const link=document.createElement('link');
      link.id='wa-font-link';
      link.rel='stylesheet';
      link.href='https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@300;400;500;600;700&family=Noto+Sans+JP:wght@300;400;500;700&display=swap';
      document.head.appendChild(link);
    }
  },[]);
  return <style>{`* { box-sizing: border-box; }`}</style>;
}

// ─── 和風デコレーション ───────────────────────────────────────────────────────
function WaPattern({color="rgba(0,0,0,0.04)"}){
  // 麻の葉風の薄いSVG背景
  return (
    <div style={{position:"absolute",inset:0,pointerEvents:"none",opacity:0.6,overflow:"hidden"}}>
      <svg width="100%" height="100%" style={{position:"absolute",top:0,left:0}}>
        <defs>
          <pattern id="hemp" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M20 0 L40 20 L20 40 L0 20 Z" fill="none" stroke={color} strokeWidth="0.8"/>
            <path d="M20 0 L20 40 M0 20 L40 20" fill="none" stroke={color} strokeWidth="0.4"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#hemp)"/>
      </svg>
    </div>
  );
}

// ─── 和風区切り線 ─────────────────────────────────────────────────────────────
function WaDivider({color="#c8a882",style:sx={}}){
  return (
    <div style={{display:"flex",alignItems:"center",gap:8,margin:"4px 0",...sx}}>
      <div style={{flex:1,height:1,background:`linear-gradient(90deg,transparent,${color})`}}/>
      <div style={{width:5,height:5,borderRadius:"50%",background:color,flexShrink:0}}/>
      <div style={{flex:1,height:1,background:`linear-gradient(90deg,${color},transparent)`}}/>
    </div>
  );
}

// ─── 上質なモーダル（和風） ───────────────────────────────────────────────────
function Modal({title,children,onClose,season}){
  const th = season ? SEASON_THEME[season] : THEME_DEFAULT;
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(10,10,20,0.6)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(2px)"}}>
      <div style={{background:"#fff",borderRadius:2,padding:0,minWidth:340,maxWidth:600,width:"92%",maxHeight:"88vh",overflowY:"auto",boxShadow:"0 30px 80px rgba(0,0,0,0.35)",border:"1px solid #e8e0d4",position:"relative"}}>
        {/* 上部アクセントライン */}
        <div style={{height:3,background:th.headerBg,borderRadius:"2px 2px 0 0"}}/>
        <div style={{padding:"24px 28px 28px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <h3 style={{margin:0,fontSize:16,fontWeight:600,color:"#2a1f14",letterSpacing:1,fontFamily:"'Noto Serif JP',serif"}}>{title}</h3>
            {onClose&&<button onClick={onClose} style={{border:"1px solid #e0d8cc",background:"#faf8f5",borderRadius:"50%",width:28,height:28,cursor:"pointer",color:"#8a7060",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>✕</button>}
          </div>
          <WaDivider color={th.accentBorder}/>
          <div style={{marginTop:16}}>{children}</div>
        </div>
      </div>
    </div>
  );
}

// ─── ボタン（和風） ───────────────────────────────────────────────────────────
function Btn({children,onClick,disabled,color="primary",size="md",style:sx={},season}){
  const th = (season && SEASON_THEME[season]) ? SEASON_THEME[season] : THEME_DEFAULT;
  const C = {
    primary: th.accent,
    danger:  "#8b2020",
    success: th.saveBg,
    gray:    "#7a6e64",
    info:    "#0369a1",
  };
  const S = {
    sm:{ padding:"5px 14px",fontSize:12,letterSpacing:0.8 },
    md:{ padding:"10px 24px",fontSize:14,letterSpacing:1 },
    lg:{ padding:"13px 36px",fontSize:15,letterSpacing:1.5 },
  };
  return (
    <button
      onClick={e=>{e.stopPropagation();if(onClick)onClick(e);}}
      disabled={disabled}
      style={{
        background: disabled?"#d4cdc6":C[color],
        color: disabled?"#a09890":"#fff",
        border:"none",
        borderRadius:1,
        cursor: disabled?"not-allowed":"pointer",
        fontWeight:500,
        fontFamily:"'Noto Serif JP',serif",
        transition:"opacity 0.15s,transform 0.1s",
        ...S[size],...sx
      }}
      onMouseEnter={e=>{ if(!disabled) e.currentTarget.style.opacity="0.85"; }}
      onMouseLeave={e=>{ e.currentTarget.style.opacity="1"; }}
    >{children}</button>
  );
}

// ─── 入力欄（和風） ──────────────────────────────────────────────────────────
function Input({label,value,onChange,type="text",placeholder="",autoFocus=false,onKeyDown,season}){
  const th = (season && SEASON_THEME[season]) ? SEASON_THEME[season] : THEME_DEFAULT;
  return (
    <div style={{marginBottom:18}}>
      {label&&<label style={{display:"block",fontWeight:500,marginBottom:6,color:"#4a3728",fontSize:13,letterSpacing:0.8,fontFamily:"'Noto Serif JP',serif"}}>{label}</label>}
      <input
        type={type} value={value}
        onChange={e=>onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
        style={{
          width:"100%",padding:"10px 14px",
          border:`1px solid ${th.accentBorder}`,
          borderRadius:1,fontSize:14,
          boxSizing:"border-box",outline:"none",
          background:"#fdf9f5",
          color:"#2a1f14",
          fontFamily:"'Noto Sans JP',sans-serif",
          transition:"border-color 0.15s",
        }}
        onFocus={e=>{ e.target.style.borderColor=th.accent; e.target.style.boxShadow=`0 0 0 2px ${th.accentLight}`; }}
        onBlur={e=>{ e.target.style.borderColor=th.accentBorder; e.target.style.boxShadow="none"; }}
      />
    </div>
  );
}

// 画像アップロードコンポーネント（変更なし・内部スタイルのみ）
function ImageUploader({value, onChange, label}){
  const fileRef = useRef(null);
  const [preview, setPreview] = useState(value||"");
  const [tab, setTab] = useState(value && !value.startsWith("data:") ? "url" : "upload");
  const [dragging, setDragging] = useState(false);
  const [uploading, setUploading] = useState(false);
  useEffect(()=>{ setPreview(value||""); },[value]);

  async function uploadToCloudinary(file){
    if(!file) return;
    if(!file.type.startsWith("image/")){ alert("画像ファイルを選択してください"); return; }
    setUploading(true);
    try{
      const fd = new FormData();
      fd.append("file", file);
      fd.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
      fd.append("folder", "menu-system");
      const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`, {method:"POST", body:fd});
      const data = await res.json();
      if(data.secure_url){
        setPreview(data.secure_url);
        onChange(data.secure_url);
      } else {
        alert("アップロードに失敗しました");
      }
    }catch(e){
      alert("アップロードエラー："+e.message);
    }finally{
      setUploading(false);
      if(fileRef.current) fileRef.current.value="";
    }
  }
  function handleFile(e){ uploadToCloudinary(e.target.files[0]); }
  function handleUrlChange(v){ setPreview(v); onChange(v); }
  function handleClear(){ setPreview(""); onChange(""); if(fileRef.current) fileRef.current.value=""; }
  function handleDrop(e){
    e.preventDefault(); setDragging(false);
    const file=e.dataTransfer.files[0];
    if(file) uploadToCloudinary(file);
  }
  function handleDragOver(e){ e.preventDefault(); setDragging(true); }
  function handleDragLeave(){ setDragging(false); }

  return (
    <div style={{marginBottom:16}}>
      {label!==false && <label style={{display:"block",fontWeight:500,marginBottom:6,color:"#4a3728",fontSize:13,letterSpacing:0.8}}>{label||"料理の写真"}</label>}
      <div style={{display:"flex",gap:0,marginBottom:10,border:"1px solid #d4c8b8",borderRadius:2,overflow:"hidden",width:"fit-content"}}>
        {[["upload","📁 ファイル"],["url","🔗 URL"]].map(([t,lbl])=>(
          <button key={t} onClick={()=>setTab(t)} style={{padding:"7px 18px",border:"none",cursor:"pointer",fontWeight:500,fontSize:12,
            background:tab===t?"#7a3d1a":"#faf8f5",color:tab===t?"#fff":"#7a6e64"}}>{lbl}</button>
        ))}
      </div>
      {tab==="upload" && (
        <div>
          <div
            onClick={()=>{ if(!uploading) fileRef.current?.click(); }}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            style={{border:"1px dashed "+(dragging?"#7a3d1a":"#c8b89a"),borderRadius:2,padding:"20px",textAlign:"center",cursor:uploading?"not-allowed":"pointer",background:dragging?"#fdf0e4":uploading?"#f5f0ea":"#fdf9f5",marginBottom:8,transition:"all 0.15s"}}>
            {uploading ? (
              <>
                <div style={{fontSize:22,marginBottom:6}}>⏳</div>
                <div style={{fontSize:12,color:"#7a3d1a"}}>Cloudinaryにアップロード中...</div>
              </>
            ) : (
              <>
                <div style={{fontSize:24,marginBottom:6}}>{dragging?"📂":"📷"}</div>
                <div style={{fontSize:12,color:"#8a7060"}}>クリックまたはドラッグ＆ドロップ</div>
                <div style={{fontSize:10,color:"#b0a090",marginTop:4}}>JPG / PNG / WebP</div>
              </>
            )}
          </div>
          <input ref={fileRef} type="file" accept="image/*" onChange={handleFile} style={{display:"none"}}/>
        </div>
      )}
      {tab==="url" && (
        <input type="text" value={tab==="url"?(preview.startsWith("data:")?"":preview):""}
          onChange={e=>handleUrlChange(e.target.value)} placeholder="https://example.com/image.jpg"
          style={{width:"100%",padding:"10px 14px",border:"1px solid #d4c8b8",borderRadius:2,fontSize:13,boxSizing:"border-box",background:"#fdf9f5"}}/>
      )}
      {preview && (
        <div style={{marginTop:10,position:"relative",display:"inline-block"}}>
          <img src={preview} alt="プレビュー" style={{width:120,height:90,objectFit:"cover",borderRadius:2,border:"1px solid #d4c8b8",display:"block"}}
            onError={()=>{ setPreview(""); onChange(""); }}/>
          <button onClick={handleClear} style={{position:"absolute",top:-6,right:-6,background:"#8b2020",color:"#fff",border:"none",borderRadius:"50%",width:20,height:20,fontSize:12,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
          <div style={{fontSize:10,color:"#8a7060",marginTop:4}}>プレビュー</div>
        </div>
      )}
    </div>
  );
}

// ─── 閲覧専用画面 ──────────────────────────────────────────────────────────────
function BrowseScreen({menus,categories,seasonStatus,onBack}){
  const [season,setSeason]=useState(null);
  const [scrolled,setScrolled]=useState(false);

  useEffect(()=>{
    function onScroll(){ setScrolled(window.scrollY>10); }
    window.addEventListener("scroll",onScroll,{passive:true});
    return ()=>window.removeEventListener("scroll",onScroll);
  },[]);

  const th=SEASON_THEME[season]||THEME_DEFAULT;
  const sortedCats=[...categories].sort((a,b)=>a.order-b.order);

  // 季節選択画面
  if(!season){
    return (
      <>
        <FontStyle/>
        <div style={{minHeight:"100vh",background:"linear-gradient(160deg,#fdf8f2 0%,#faf0e4 50%,#fdf6ee 100%)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:20,position:"relative",overflow:"hidden"}}>
          <WaPattern color="rgba(120,80,40,0.05)"/>
          <div style={{textAlign:"center",maxWidth:440,width:"100%",position:"relative",zIndex:1}}>
            <div style={{fontSize:11,color:"#b09070",letterSpacing:4,marginBottom:8,fontFamily:"'Noto Serif JP',serif"}}>メニュー閲覧</div>
            <div style={{width:60,height:1,background:"linear-gradient(90deg,transparent,#c8a882,transparent)",margin:"0 auto 24px"}}/>
            <h2 style={{fontSize:18,fontWeight:600,color:"#2a1a0e",letterSpacing:2,marginBottom:8,fontFamily:"'Noto Serif JP',serif"}}>季節を選んでください</h2>
            <WaDivider color="#c8a882" style={{margin:"12px auto 28px",maxWidth:200}}/>
            <div style={{display:"flex",flexDirection:"column",gap:10,alignItems:"center",width:"100%",padding:"0 16px",boxSizing:"border-box"}}>
              {SEASON_LIST.map(s=>{
                const th2=SEASON_THEME[s]||THEME_DEFAULT;
                return (
                  <button key={s} onClick={()=>setSeason(s)}
                    style={{width:"100%",maxWidth:320,padding:"14px 0",background:th2.headerBg,color:"#fff",border:"none",borderRadius:1,cursor:"pointer",fontSize:13,fontWeight:500,letterSpacing:2,fontFamily:"'Noto Serif JP',serif"}}
                    onMouseEnter={e=>e.currentTarget.style.opacity="0.85"}
                    onMouseLeave={e=>e.currentTarget.style.opacity="1"}
                  >{th2.motif} {s}のメニュー</button>
                );
              })}
            </div>
            <div style={{marginTop:32,fontSize:12,color:"#c8b8a0",letterSpacing:1,cursor:"pointer",fontFamily:"'Noto Serif JP',serif"}} onClick={onBack}>← TOPに戻る</div>
          </div>
        </div>
      </>
    );
  }

  // メニュー一覧画面（閲覧専用）
  const seasonMenus=withNos(menus.filter(m=>m.season===season));
  const uncategorized=seasonMenus.filter(m=>!m.categoryId||m.categoryId==="null");
  const catGroups=sortedCats.map(cat=>({cat,items:seasonMenus.filter(m=>String(m.categoryId)===String(cat.id))})).filter(g=>g.items.length>0);
  if(uncategorized.length>0) catGroups.push({cat:{id:null,name:"その他"},items:uncategorized});

  return (
    <>
      <FontStyle/>
      <div style={{minHeight:"100vh",background:th.bg,fontFamily:"'Noto Serif JP',serif",transition:"background 0.4s"}}>

        {/* ヘッダー */}
        <div style={{
          position:"fixed",top:0,left:0,right:0,zIndex:200,
          background:th.headerBg,color:th.headerText,
          padding:scrolled?"8px 20px":"14px 24px",
          transition:"padding 0.2s",
          boxShadow:"0 2px 20px rgba(0,0,0,0.25)"
        }}>
          <div style={{maxWidth:960,margin:"0 auto",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
            <div>
              <div style={{fontWeight:500,fontSize:scrolled?14:18,letterSpacing:2,transition:"font-size 0.2s",lineHeight:1.2,fontFamily:"'Noto Serif JP',serif"}}>
                {th.motif} {season}のメニュー {th.motif}
              </div>
              {!scrolled&&<div style={{fontSize:11,opacity:0.85,marginTop:4,letterSpacing:0.5,fontFamily:"'Noto Sans JP',sans-serif"}}>閲覧専用</div>}
            </div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setSeason(null)}
                style={{padding:"5px 14px",background:"rgba(255,255,255,0.18)",color:"#fff",border:"1px solid rgba(255,255,255,0.35)",borderRadius:1,cursor:"pointer",fontSize:11,letterSpacing:1,fontFamily:"'Noto Serif JP',serif"}}>
                季節
              </button>
              <button onClick={onBack}
                style={{padding:"5px 14px",background:"rgba(255,255,255,0.18)",color:"#fff",border:"1px solid rgba(255,255,255,0.35)",borderRadius:1,cursor:"pointer",fontSize:11,letterSpacing:1,fontFamily:"'Noto Serif JP',serif"}}>
                TOP
              </button>
            </div>
          </div>
        </div>

        {/* メインコンテンツ */}
        <div style={{maxWidth:960,margin:"0 auto",padding:`${scrolled?46:68+24}px 24px 40px`,transition:"padding-top 0.2s",position:"relative",zIndex:1}}>

          {(seasonStatus||{})[season]==="preparing" ? (
            <div style={{textAlign:"center",padding:"48px 24px",background:"rgba(255,255,255,0.85)",border:`1px solid ${th.accentBorder}`,borderRadius:2,marginTop:24}}>
              <div style={{fontSize:28,marginBottom:16,opacity:0.6}}>{th.motif}</div>
              <div style={{fontSize:16,fontWeight:600,color:th.accent,letterSpacing:2,marginBottom:10,fontFamily:"'Noto Serif JP',serif"}}>
                現在準備中につき今しばらくお待ちくださいませ
              </div>
              <WaDivider color={th.accentBorder} style={{maxWidth:200,margin:"0 auto"}}/>
              <div style={{fontSize:12,color:"#8a7060",marginTop:12,letterSpacing:0.8,fontFamily:"'Noto Serif JP',serif"}}>
                <div>{season}のメニューは現在準備中です。</div>
                <div>施設スタッフにお声がけください。</div>
              </div>
            </div>
          ) : seasonMenus.length===0 ? (
            <div style={{textAlign:"center",padding:"48px 24px",background:"rgba(255,255,255,0.85)",border:`1px solid ${th.accentBorder}`,borderRadius:2,marginTop:24}}>
              <div style={{fontSize:28,marginBottom:16,opacity:0.6}}>{th.motif}</div>
              <div style={{fontSize:15,color:th.accent,letterSpacing:2,fontFamily:"'Noto Serif JP',serif"}}>現在メニューはありません</div>
            </div>
          ) : (
            catGroups.map(({cat,items})=>(
              <div key={cat.id||"uncat"} style={{marginBottom:32}}>
                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:14}}>
                  <div style={{width:3,height:20,background:th.headerBg,borderRadius:2,flexShrink:0}}/>
                  <div style={{fontSize:13,fontWeight:600,color:th.catLabel,letterSpacing:2,fontFamily:"'Noto Serif JP',serif"}}>{cat.name}</div>
                  <div style={{flex:1,height:1,background:`linear-gradient(90deg,${th.accentBorder},transparent)`}}/>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(min(280px,100%),1fr))",gap:16}}>
                  {items.map(m=>(
                    <div key={m.id} style={{
                      borderRadius:2,overflow:"hidden",
                      border:`2px solid ${th.cardBorder}`,
                      boxShadow:"0 2px 10px rgba(0,0,0,0.06)",
                      background:th.cardBg,
                      display:"flex",flexDirection:"column",
                    }}>
                      <div style={{width:"100%",height:170,overflow:"hidden",position:"relative",flexShrink:0}}>
                        {m.img ? (
                          <img src={m.img} alt={m.name} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}
                            onError={e=>e.target.style.display="none"}/>
                        ) : (
                          <div style={{width:"100%",height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",background:th.noImgBg}}>
                            <div style={{fontSize:36,marginBottom:6,opacity:0.5}}>🍽️</div>
                            <div style={{fontSize:10,letterSpacing:2,color:th.noImgText,fontFamily:"'Noto Serif JP',serif"}}>お料理の写真</div>
                          </div>
                        )}
                        <div style={{position:"absolute",bottom:0,left:0,background:"rgba(0,0,0,0.45)",color:"rgba(255,255,255,0.9)",fontSize:10,padding:"3px 8px",letterSpacing:0.5,fontFamily:"'Noto Sans JP',sans-serif"}}>
                          No.{m.no}
                        </div>
                      </div>
                      <div style={{padding:"12px 14px",display:"flex",flexDirection:"column",gap:5,flex:1}}>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                          <div style={{fontSize:14,fontWeight:600,color:"#2a1a0e",lineHeight:1.4,flex:1,fontFamily:"'Noto Serif JP',serif"}}>{m.name}</div>
                          <div style={{whiteSpace:"nowrap",background:th.ptBg,color:th.ptColor,padding:"2px 8px",borderRadius:1,flexShrink:0,border:`1px solid ${th.ptBorder}`,fontSize:12,fontWeight:700,fontFamily:"'Noto Sans JP',sans-serif"}}>{m.points}pt</div>
                        </div>
                        {m.desc&&<div style={{fontSize:11,color:"#8a7060",lineHeight:1.6,letterSpacing:0.3,fontFamily:"'Noto Sans JP',sans-serif"}}>{m.desc}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}

// ─── TOPページ ────────────────────────────────────────────────────────────────
function App(){
  const [screen,setScreen]=useState(()=>{
    try{ return sessionStorage.getItem("ss_screen")||"startup"; }catch{ return "startup"; }
  });
  const [menus,setMenus]=useState([]);
  const [categories,setCategories]=useState([]);
  const [orders,setOrders]=useState({});
  const [seasonStatus,setSeasonStatus]=useState({春:"open",夏:"open",秋:"open",冬:"open"});
  const [siteConfig,setSiteConfig]=useState({
    logoUrl:"",
    faviconUrl:"",
    title:"料理選択システム",
    subtitle:"旬の食材を活かした季節の膳",
    slides:[]
  });
  const [session,setSession]=useState(()=>{
    try{
      const s=sessionStorage.getItem("ss_session");
      return s?JSON.parse(s):null;
    }catch{ return null; }
  });
  const [adminAuthed,setAdminAuthed]=useState(false);
  const [loading,setLoading]=useState(true);
  function saveScreen(s){
    try{ sessionStorage.setItem("ss_screen",s); }catch{}
    setScreen(s);
  }
  function saveSession(s){
    try{
      if(s) sessionStorage.setItem("ss_session",JSON.stringify(s));
      else sessionStorage.removeItem("ss_session");
    }catch{}
    setSession(s);
  }
  const [slideIdx,setSlideIdx]=useState(0);
  useEffect(()=>{
    if(!siteConfig.slides||siteConfig.slides.length<=1){ setSlideIdx(0); return; }
    const t=setInterval(()=>setSlideIdx(i=>(i+1)%siteConfig.slides.length),4000);
    return ()=>clearInterval(t);
  },[siteConfig.slides]);
  useEffect(()=>{
    if(!siteConfig.faviconUrl) return;
    let link=document.querySelector("link[rel~='icon']");
    if(!link){ link=document.createElement("link"); link.rel="icon"; document.head.appendChild(link); }
    link.href=siteConfig.faviconUrl;
  },[siteConfig.faviconUrl]);

  // Pull-to-Refresh（スワイプ更新）防止
  useEffect(()=>{
    let startY=0;
    function onTouchStart(e){ startY=e.touches[0].clientY; }
    function onTouchMove(e){
      const dy=e.touches[0].clientY-startY;
      if(dy>0 && window.scrollY===0) e.preventDefault();
    }
    document.addEventListener("touchstart",onTouchStart,{passive:true});
    document.addEventListener("touchmove",onTouchMove,{passive:false});
    return ()=>{
      document.removeEventListener("touchstart",onTouchStart);
      document.removeEventListener("touchmove",onTouchMove);
    };
  },[]);

  useEffect(()=>{
    (async()=>{
      try{
        // menus
        let m = null;
        try{ m = await sget("menus"); }catch{}
        if(!m || !Array.isArray(m) || m.length===0){
          m = DEFAULT_MENUS;
          try{ await sset("menus", m); }catch{}
        }
        setMenus(m);

        // categories
        let c = null;
        try{ c = await sget("categories"); }catch{}
        if(!c || !Array.isArray(c) || c.length===0){
          c = DEFAULT_CATEGORIES;
          try{ await sset("categories", c); }catch{}
        }
        setCategories(c);

        // orders
        let o = null;
        try{ o = await sget("orders"); }catch{}
        setOrders((o && typeof o==="object") ? o : {});

        // seasonStatus
        let ss = null;
        try{ ss = await sget("seasonStatus"); }catch{}
        if(ss && typeof ss==="object") setSeasonStatus(ss);

        // siteConfig
        let sc = null;
        try{ sc = await sget("siteConfig"); }catch{}
        if(sc && typeof sc==="object") setSiteConfig(prev=>({...prev,...sc}));

      }catch(e){
        // 最終フォールバック：デフォルトデータで起動
        console.error("Storage init error:", e);
        setMenus(DEFAULT_MENUS);
        setCategories(DEFAULT_CATEGORIES);
        setOrders({});
      }
      setLoading(false);
    })();
  },[]);

  // Firestore読み込み完了後にsessionStorageのsessionを検証
  useEffect(()=>{
    if(loading) return;
    // screenがcartsなのにsessionがnullの場合はstartupに戻す
    if(screen==="carts"&&!session){ saveScreen("startup"); }
    // sessionがある場合、そのreservationNoがordersに存在するか確認
    // （別端末で削除された注文のsessionが残っている場合の対処）
    if(session&&screen==="carts"&&orders&&Object.keys(orders).length>0){
      if(!orders[session.reservationNo]){
        // ordersにない場合はセッションをクリアしてTOPへ
        saveSession(null); saveScreen("startup");
      }
    }
  },[loading]);

  const [menuHistory,setMenuHistory]=useState([]);
  useEffect(()=>{ sget("menuHistory").then(v=>{ if(v) setMenuHistory(v); }); },[]);
  async function saveMenuHistory(h){ setMenuHistory(h); await sset("menuHistory",h); }
  async function saveMenus(m){setMenus(m);await sset("menus",m);}
  async function saveCategories(c){setCategories(c);await sset("categories",c);}
  async function saveOrders(o){setOrders(o);await sset("orders",o);}
  async function saveSeasonStatus(ss){setSeasonStatus(ss);await sset("seasonStatus",ss);}
  async function saveSiteConfig(sc){setSiteConfig(sc);await sset("siteConfig",sc);}

  if(loading) return (
    <>
      <FontStyle/>
      <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100vh",background:"#fdf6ee",gap:16}}>
        <div style={{fontSize:32}}>🍽️</div>
        <div style={{fontSize:15,color:"#8a7060",letterSpacing:2}}>読み込み中...</div>
      </div>
    </>
  );
  if(screen==="admin") return <AdminScreen menus={menus} saveMenus={saveMenus} categories={categories} saveCategories={saveCategories} orders={orders} saveOrders={saveOrders} seasonStatus={seasonStatus} saveSeasonStatus={saveSeasonStatus} siteConfig={siteConfig} saveSiteConfig={saveSiteConfig} menuHistory={menuHistory} saveMenuHistory={saveMenuHistory} onBack={()=>saveScreen("startup")} authed={adminAuthed} setAuthed={setAdminAuthed}/>;
  if(screen==="carts") return <CartScreen session={session} setSession={saveSession} menus={menus} categories={categories} orders={orders} saveOrders={saveOrders} seasonStatus={seasonStatus} onBack={()=>saveScreen("startup")}/>;
  if(screen==="setup") return <SetupScreen orders={orders} onDone={s=>{setSession(s);saveScreen("carts");}} onBack={()=>saveScreen("startup")}/>;
  if(screen==="welcome") return <WelcomeScreen orders={orders} onContinue={s=>{ setSession(s); saveScreen("carts"); }} onBack={()=>saveScreen("startup")}/>;
  if(screen==="browse") return <BrowseScreen menus={menus} categories={categories} seasonStatus={seasonStatus} onBack={()=>saveScreen("startup")}/>;

  return (
    <>
      <FontStyle/>
      <div style={{minHeight:"100vh",background:"linear-gradient(160deg,#fdf8f2 0%,#faf0e4 50%,#fdf6ee 100%)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:20,position:"relative",overflow:"hidden"}}>
        <WaPattern color="rgba(120,80,40,0.05)"/>
        <div style={{position:"absolute",top:-60,right:-60,width:240,height:240,borderRadius:"50%",background:"radial-gradient(circle,rgba(180,120,80,0.08),transparent 70%)",pointerEvents:"none"}}/>
        <div style={{position:"absolute",bottom:-40,left:-40,width:180,height:180,borderRadius:"50%",background:"radial-gradient(circle,rgba(180,120,80,0.06),transparent 70%)",pointerEvents:"none"}}/>

        <div style={{textAlign:"center",maxWidth:440,width:"100%",position:"relative",zIndex:1}}>
          {/* ① ラベル */}
          <div style={{marginBottom:8,fontSize:11,letterSpacing:4,color:"#b09070",fontFamily:"'Noto Serif JP',serif"}}>お料理選択</div>
          <div style={{width:60,height:1,background:"linear-gradient(90deg,transparent,#c8a882,transparent)",margin:"0 auto 24px"}}/>

          {/* ② ロゴ */}
          {siteConfig.logoUrl ? (
            <div style={{marginBottom:12,display:"flex",justifyContent:"center"}}>
              <img src={siteConfig.logoUrl} alt="logo" style={{maxHeight:96,maxWidth:300,objectFit:"contain",display:"block"}}
                onError={e=>e.target.style.display="none"}/>
            </div>
          ) : (
            <div style={{fontSize:44,marginBottom:12,lineHeight:1}}>🍽️</div>
          )}

          {/* タイトル：最大16文字・1行収まるフォントサイズ自動調整 */}
          {(()=>{
            const t=(siteConfig.title||"料理選択システム").slice(0,16);
            const len=t.length;
            const fs=len<=6?28:len<=8?24:len<=10?20:len<=13?17:15;
            const ls=len<=8?3:len<=12?2:1;
            return (
              <h1 style={{fontSize:fs,fontWeight:600,color:"#2a1a0e",margin:"0 auto 10px",letterSpacing:ls,fontFamily:"'Noto Serif JP',serif",lineHeight:1.4,whiteSpace:"nowrap",textAlign:"center",width:"100%"}}>
                {t}
              </h1>
            );
          })()}

          {/* ④ サブタイトル */}
          <p style={{color:"#8a7060",marginBottom:8,fontSize:11,letterSpacing:1.5,fontFamily:"'Noto Serif JP',serif"}}>
            {siteConfig.subtitle||"旬の食材を活かした季節の膳"}
          </p>

          {/* ⑤ 写真スライド */}
          {siteConfig.slides&&siteConfig.slides.length>0 && (
            <div style={{margin:"16px auto",width:"100%",maxWidth:208,position:"relative",borderRadius:2,overflow:"hidden",boxShadow:"0 4px 16px rgba(0,0,0,0.12)"}}>
              {siteConfig.slides.map((url,i)=>(
                <div key={i} style={{
                  position:i===0?"relative":"absolute",
                  top:0,left:0,width:"100%",
                  opacity:i===slideIdx?1:0,
                  transition:"opacity 0.8s ease",
                  pointerEvents:i===slideIdx?"auto":"none"
                }}>
                  <img src={url} alt={"slide"+i} style={{width:"100%",height:128,objectFit:"cover",display:"block"}}
                    onError={e=>e.target.style.display="none"}/>
                </div>
              ))}
              {siteConfig.slides.length>1 && (
                <div style={{position:"absolute",bottom:6,left:0,right:0,display:"flex",justifyContent:"center",gap:5}}>
                  {siteConfig.slides.map((_,i)=>(
                    <div key={i} onClick={()=>setSlideIdx(i)} style={{width:6,height:6,borderRadius:"50%",background:i===slideIdx?"#fff":"rgba(255,255,255,0.5)",cursor:"pointer",transition:"background 0.3s"}}/>
                  ))}
                </div>
              )}
            </div>
          )}

          <WaDivider color="#c8a882" style={{margin:"16px auto 32px",maxWidth:200}}/>

          <div style={{display:"flex",flexDirection:"column",gap:12,alignItems:"center",width:"100%",padding:"0 16px",boxSizing:"border-box"}}>
            <button
              onClick={()=>saveScreen("welcome")}
              style={{width:"100%",maxWidth:320,padding:"14px 0",background:"#7a3d1a",color:"#fff",border:"none",borderRadius:1,cursor:"pointer",fontSize:13,fontWeight:500,letterSpacing:2,fontFamily:"'Noto Serif JP',serif",position:"relative",overflow:"hidden"}}
              onMouseEnter={e=>e.currentTarget.style.background="#5e2e12"}
              onMouseLeave={e=>e.currentTarget.style.background="#7a3d1a"}
            >
              前回のつづきから
            </button>
            <button
              onClick={()=>saveScreen("setup")}
              style={{width:"100%",maxWidth:320,padding:"14px 0",background:"transparent",color:"#7a3d1a",border:"1px solid #c8a882",borderRadius:1,cursor:"pointer",fontSize:13,fontWeight:500,letterSpacing:2,fontFamily:"'Noto Serif JP',serif"}}
              onMouseEnter={e=>{ e.currentTarget.style.background="#fde8cc"; }}
              onMouseLeave={e=>{ e.currentTarget.style.background="transparent"; }}
            >
              最初から始める
            </button>
            <button
              onClick={()=>saveScreen("browse")}
              style={{width:"100%",maxWidth:320,padding:"10px 0",background:"transparent",color:"#8a7060",border:"1px dashed #c8b89a",borderRadius:1,cursor:"pointer",fontSize:12,fontWeight:500,letterSpacing:2,fontFamily:"'Noto Serif JP',serif"}}
              onMouseEnter={e=>{ e.currentTarget.style.background="#fdf6ee"; }}
              onMouseLeave={e=>{ e.currentTarget.style.background="transparent"; }}
            >
              📋 メニューを見る
            </button>
          </div>

          <div style={{marginTop:48,fontSize:11,color:"#c8b8a0",letterSpacing:2,cursor:"pointer",fontFamily:"'Noto Serif JP',serif"}}
            onClick={()=>saveScreen("admin")}>施設担当者専用</div>
        </div>
      </div>
    </>
  );
}

// ─── つづきから画面 ──────────────────────────────────────────────────────────
function WelcomeScreen({orders,onContinue,onBack}){
  const [no,setNo]=useState("");
  const [date,setDate]=useState("");
  const [rep,setRep]=useState("");
  const [err,setErr]=useState("");

  function handleContinue(){
    const o=orders[no];
    if(!o){ setErr("予約番号が見つかりませんでした。"); return; }
    if(fmtDate(o.date)!==fmtDate(date)){ setErr("利用日が一致しません。"); return; }
    if((o.representative||"").trim()!==rep.trim()){ setErr("代表者名が一致しません。"); return; }
    onContinue({...o});
  }

  const th = THEME_DEFAULT;
  return (
    <>
      <FontStyle/>
      <div style={{minHeight:"100vh",background:"linear-gradient(160deg,#fdf8f2,#faf0e4 50%,#fdf6ee)",display:"flex",alignItems:"center",justifyContent:"center",padding:20,position:"relative",overflow:"hidden"}}>
        <WaPattern color="rgba(120,80,40,0.04)"/>
        <div style={{background:"#fff",borderRadius:2,padding:"36px 40px",maxWidth:420,width:"100%",boxShadow:"0 16px 60px rgba(60,30,10,0.14)",border:"1px solid #e8ddd0",position:"relative",zIndex:1}}>
          <div style={{height:2,background:th.headerBg,margin:"-36px -40px 28px",borderRadius:"2px 2px 0 0"}}/>
          <div style={{fontSize:11,color:"#b09070",letterSpacing:3,marginBottom:8,fontFamily:"'Noto Serif JP',serif"}}>前回のつづき</div>
          <h2 style={{margin:"0 0 6px",fontSize:20,fontWeight:600,color:"#2a1a0e",letterSpacing:1,fontFamily:"'Noto Serif JP',serif"}}>予約情報の確認</h2>
          <WaDivider color={th.accentBorder} style={{margin:"12px 0 20px"}}/>
          <p style={{color:"#8a7060",marginBottom:22,fontSize:12,letterSpacing:0.5,lineHeight:1.7}}>予約番号・利用日・代表者名の3項目を入力して情報を復元します</p>
          <Input season="春" label="予約番号" value={no} onChange={v=>{setNo(v);setErr("");}} placeholder="例：R-20250101-001"/>
          <Input season="春" label="利用日" value={date} onChange={v=>{setDate(v);setErr("");}} type="date"/>
          <Input season="春" label="代表者名" value={rep} onChange={v=>{setRep(v);setErr("");}} placeholder="例：山田 太郎"/>
          {err&&<div style={{color:"#8b2020",fontSize:12,marginTop:-10,marginBottom:14,padding:"8px 12px",background:"#fdf0f0",border:"1px solid #e8c0b8",borderRadius:1}}>⚠ {err}</div>}
          <div style={{display:"flex",gap:10,marginTop:10}}>
            <Btn season="春" onClick={handleContinue} disabled={!no||!date||!rep} style={{flex:1}}>復元する</Btn>
            <Btn season="春" color="gray" onClick={onBack} style={{flex:1}}>戻る</Btn>
          </div>
        </div>
      </div>
    </>
  );
}

// ─── 最初から始める画面 ───────────────────────────────────────────────────────
function SetupScreen({orders,onDone,onBack}){
  const [reservationNo,setReservationNo]=useState("");
  const [date,setDate]=useState("");
  const [representative,setRepresentative]=useState("");
  const [numCarts,setNumCarts]=useState(1);
  const [cartNames,setCartNames]=useState([""]);
  const [step,setStep]=useState(1);
  const [noErr,setNoErr]=useState("");
  const season=getSeason(date)||"春";
  const th=SEASON_THEME[season]||THEME_DEFAULT;

  const DUMMY_NAMES=["山田 太郎","佐藤 花子","鈴木 一郎","田中 美咲","伊藤 健太","渡辺 由美","中村 拓也","小林 直子","加藤 誠","吉田 恵子","山本 浩二","松本 さくら","井上 大輔","木村 奈々","林 雄介","清水 陽子","山口 翔太","池田 彩","橋本 龍一","石川 みか"];

  function handleNumChange(n){
    const num=Math.max(1,Math.min(20,Number(n)));
    setNumCarts(num);
    setCartNames(Array.from({length:num},(_,i)=>cartNames[i]||""));
  }
  function handleNext(){
    if(orders&&orders[reservationNo]){ setNoErr("この予約番号はすでに登録されています。「前回のつづきから」をご利用ください。"); return; }
    setNoErr(""); setStep(2);
  }

  return (
    <>
      <FontStyle/>
      <div style={{minHeight:"100vh",background:th.bg,display:"flex",alignItems:"center",justifyContent:"center",padding:20,position:"relative",overflow:"hidden",transition:"background 0.4s"}}>
        <WaPattern color="rgba(120,80,40,0.04)"/>
        <div style={{background:"#fff",borderRadius:2,padding:"36px 40px",maxWidth:480,width:"100%",boxShadow:"0 16px 60px rgba(60,30,10,0.14)",border:"1px solid #e8ddd0",position:"relative",zIndex:1}}>
          <div style={{height:2,background:th.headerBg,margin:"-36px -40px 28px",borderRadius:"2px 2px 0 0"}}/>

          {step===1 && (
            <>
              <div style={{fontSize:11,color:th.accent,letterSpacing:3,marginBottom:8,fontFamily:"'Noto Serif JP',serif",opacity:0.8}}>新規登録 — STEP 1 / 2</div>
              <h2 style={{margin:"0 0 4px",fontSize:20,fontWeight:600,color:"#2a1a0e",letterSpacing:1,fontFamily:"'Noto Serif JP',serif"}}>基本情報の入力</h2>
              <WaDivider color={th.accentBorder} style={{margin:"12px 0 20px"}}/>
              <Input season={season} label="① 予約番号" value={reservationNo} onChange={v=>{setReservationNo(v);setNoErr("");}} placeholder="例：R-20250101-001"/>
              {noErr&&<div style={{color:"#8b2020",fontSize:12,marginTop:-10,marginBottom:14,padding:"8px 12px",background:"#fdf0f0",border:"1px solid #e8c0b8",borderRadius:1}}>⚠ {noErr}</div>}
              <Input season={season} label="② 利用日" value={date} onChange={setDate} type="date"/>
              {date && (
                <div style={{background:th.accentLight,border:`1px solid ${th.accentBorder}`,borderRadius:1,padding:"8px 14px",marginBottom:18,fontSize:12,color:th.accent,letterSpacing:0.5}}>
                  {SEASON_EMOJI[season]} 季節：{season} のメニューが表示されます — {th.tagline}
                </div>
              )}
              <Input season={season} label="③ 代表者名" value={representative} onChange={setRepresentative} placeholder="例：山田 太郎"/>
              <div style={{display:"flex",gap:10,marginTop:10}}>
                <Btn season={season} onClick={handleNext} disabled={!reservationNo||!date||!representative} style={{flex:1}}>次へ</Btn>
                <Btn season={season} color="gray" onClick={onBack} style={{flex:1}}>戻る</Btn>
              </div>
            </>
          )}
          {step===2 && (
            <>
              <div style={{fontSize:11,color:th.accent,letterSpacing:3,marginBottom:8,fontFamily:"'Noto Serif JP',serif",opacity:0.8}}>新規登録 — STEP 2 / 2</div>
              <h2 style={{margin:"0 0 4px",fontSize:20,fontWeight:600,color:"#2a1a0e",letterSpacing:1,fontFamily:"'Noto Serif JP',serif"}}>お名前の入力</h2>
              <WaDivider color={th.accentBorder} style={{margin:"12px 0 20px"}}/>
              <div style={{marginBottom:18}}>
                <label style={{display:"block",fontWeight:500,marginBottom:8,color:"#4a3728",fontSize:13,letterSpacing:0.8,fontFamily:"'Noto Serif JP',serif"}}>人数（カート数）</label>
                <div style={{display:"flex",alignItems:"center",gap:0,border:`1px solid ${th.accentBorder}`,borderRadius:1,overflow:"hidden",width:"fit-content"}}>
                  <button onClick={()=>handleNumChange(numCarts-1)} disabled={numCarts<=1}
                    style={{width:48,height:48,border:"none",background:numCarts<=1?"#f5f0ea":"#fdf9f5",color:numCarts<=1?"#c8b89a":th.accent,fontSize:22,cursor:numCarts<=1?"not-allowed":"pointer",fontWeight:300,lineHeight:1}}>－</button>
                  <div style={{width:56,height:48,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:600,color:"#2a1f14",borderLeft:`1px solid ${th.accentBorder}`,borderRight:`1px solid ${th.accentBorder}`,background:"#fff",fontFamily:"'Noto Sans JP',sans-serif"}}>{numCarts}</div>
                  <button onClick={()=>handleNumChange(numCarts+1)} disabled={numCarts>=20}
                    style={{width:48,height:48,border:"none",background:numCarts>=20?"#f5f0ea":"#fdf9f5",color:numCarts>=20?"#c8b89a":th.accent,fontSize:22,cursor:numCarts>=20?"not-allowed":"pointer",fontWeight:300,lineHeight:1}}>＋</button>
                </div>
              </div>
              <div style={{maxHeight:220,overflowY:"auto",marginBottom:16}}>
                {cartNames.map((name,i)=>(
                  <Input key={i} season={season} label={`${i+1}名目のお名前`} value={name} onChange={v=>{const n=[...cartNames];n[i]=v;setCartNames(n);}} placeholder={`例：${DUMMY_NAMES[i%DUMMY_NAMES.length]}`}/>
                ))}
              </div>
              <div style={{display:"flex",gap:10}}>
                <Btn season={season} onClick={()=>onDone({reservationNo,date,representative,season,carts:cartNames.map(name=>({name,items:[]}))})} disabled={cartNames.some(n=>!n)} style={{flex:1}} color="success">開始する</Btn>
                <Btn season={season} color="gray" onClick={()=>setStep(1)} style={{flex:1}}>戻る</Btn>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

// ─── 料理選択画面（CartScreen） ───────────────────────────────────────────────
function CartScreen({session,setSession,menus,categories,orders,saveOrders,seasonStatus,onBack}){
  const [activeCart,setActiveCart]=useState(0);
  const [showMenuList,setShowMenuList]=useState(false);
  const [showSummary,setShowSummary]=useState(null);
  const [saved,setSaved]=useState(false);
  const [showAddCart,setShowAddCart]=useState(false);
  const [newCartName,setNewCartName]=useState("");
  const [scrolled,setScrolled]=useState(false);

  const th = SEASON_THEME[session.season] || THEME_DEFAULT;
  const isPreparing = (seasonStatus||{})[session.season] === "preparing";

  useEffect(()=>{
    function onScroll(){ setScrolled(window.scrollY>10); }
    window.addEventListener("scroll",onScroll,{passive:true});
    return ()=>window.removeEventListener("scroll",onScroll);
  },[]);

  function confirmLeave(){
    if(saved) return true;
    return window.confirm("保存されていない変更があります。\nTOPへ戻ると入力内容が失われます。続けますか？");
  }
  function handleBack(){ if(confirmLeave()) onBack(); }

  // 同じ季節のメニューを全て表示（非表示・期間外も含む）
  const seasonMenus=withNos(menus.filter(m=>m.season===session.season));
  const sortedCats=[...categories].sort((a,b)=>a.order-b.order);
  const cart=session.carts[activeCart];
  const cartPoints=cart.items.map(id=>menus.find(m=>m.id===id)).filter(Boolean).reduce((s,m)=>s+m.points,0);
  const overLimit=cartPoints>POINT_LIMIT;
  const anyOver=session.carts.some(c=>c.items.map(id=>menus.find(m=>m.id===id)).filter(Boolean).reduce((s,m)=>s+m.points,0)>POINT_LIMIT);

  function addItem(menuId){ const c=session.carts.map((x,i)=>i===activeCart?{...x,items:[...x.items,menuId]}:x); setSession({...session,carts:c}); setSaved(false); }
  function removeItem(menuId){
    const c=session.carts.map((x,i)=>{ if(i!==activeCart)return x; const items=[...x.items]; items.splice(items.lastIndexOf(menuId),1); return {...x,items}; });
    setSession({...session,carts:c}); setSaved(false);
  }
  async function handleSave(){
    const ts=new Date().toISOString();
    // カートのitemsをスナップショット形式に変換（IDと当時のメニュー情報を一緒に保存）
    const seasonMenuList=withNos(menus.filter(m=>m.season===session.season));
    const snapshotCarts=session.carts.map(c=>({
      ...c,
      itemSnapshots:c.items.map(id=>{
        const m=seasonMenuList.find(x=>x.id===id);
        if(!m) return {id};
        return {id:m.id, no:m.no, name:m.name, points:m.points, desc:m.desc||"", img:m.img||""};
      })
    }));
    await saveOrders({...orders,[session.reservationNo]:{...session,carts:snapshotCarts,updatedAt:ts,updatedBy:"user"}});
    setSaved(true); alert("✅ 保存しました");
  }
  function handleAddCart(){
    if(!newCartName.trim()) return;
    const newCarts=[...session.carts,{name:newCartName.trim(),items:[]}];
    setSession({...session,carts:newCarts});
    setSaved(false); setNewCartName(""); setShowAddCart(false);
    setActiveCart(newCarts.length-1);
  }

  const uncategorized=seasonMenus.filter(m=>!m.categoryId||m.categoryId==="null");
  const catGroups=sortedCats.map(cat=>({cat,items:seasonMenus.filter(m=>String(m.categoryId)===String(cat.id))})).filter(g=>g.items.length>0);
  if(uncategorized.length>0) catGroups.push({cat:{id:null,name:"その他"},items:uncategorized});

  const displayDate=fmtDate(session.date);
  const headerRef=useRef(null);
  const cartBarRef=useRef(null);
  const [headerH,setHeaderH]=useState(68);
  const [cartBarH,setCartBarH]=useState(54);
  const totalFixedH=headerH+cartBarH;

  // ヘッダー高さを動的に計測
  useEffect(()=>{
    function measure(){
      if(headerRef.current) setHeaderH(headerRef.current.offsetHeight);
      if(cartBarRef.current) setCartBarH(cartBarRef.current.offsetHeight);
    }
    measure();
    window.addEventListener("resize",measure);
    return ()=>window.removeEventListener("resize",measure);
  },[scrolled]);

  return (
    <>
      <FontStyle/>
      <div style={{minHeight:"100vh",background:th.bg,fontFamily:"'Noto Serif JP',serif",transition:"background 0.4s"}}>

        {/* ── 固定ヘッダー ── */}
        <div ref={headerRef} style={{
          position:"fixed",top:0,left:0,right:0,zIndex:200,
          background:th.headerBg,
          color:th.headerText,
          padding:scrolled?"8px 20px":"14px 24px",
          transition:"padding 0.2s",
          boxShadow:"0 2px 20px rgba(0,0,0,0.25)"
        }}>
          <div style={{maxWidth:960,margin:"0 auto",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
            <div>
              <div style={{fontWeight:500,fontSize:scrolled?14:18,letterSpacing:2,transition:"font-size 0.2s",lineHeight:1.2,fontFamily:"'Noto Serif JP',serif"}}>
                {th.motif} 料理選択 {th.motif}
              </div>
              {!scrolled&&<div style={{fontSize:11,opacity:0.85,marginTop:4,letterSpacing:0.5,fontFamily:"'Noto Sans JP',sans-serif"}}>
                {session.reservationNo} ｜ {displayDate} ｜ {session.representative} ｜ {session.season}のメニュー
              </div>}
            </div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setShowMenuList(true)}
                style={{padding:"5px 14px",background:"rgba(255,255,255,0.18)",color:"#fff",border:"1px solid rgba(255,255,255,0.35)",borderRadius:1,cursor:"pointer",fontSize:11,letterSpacing:1,fontFamily:"'Noto Serif JP',serif"}}>
                一覧
              </button>
              <button onClick={handleBack}
                style={{padding:"5px 14px",background:"rgba(255,255,255,0.18)",color:"#fff",border:"1px solid rgba(255,255,255,0.35)",borderRadius:1,cursor:"pointer",fontSize:11,letterSpacing:1,fontFamily:"'Noto Serif JP',serif"}}>
                TOP
              </button>
            </div>
          </div>
        </div>

        {/* ── 固定カートバー ── */}
        <div ref={cartBarRef} style={{
          position:"fixed",top:headerH,left:0,right:0,zIndex:199,
          background:"rgba(255,255,255,0.96)",
          backdropFilter:"blur(8px)",
          borderBottom:`1px solid ${th.accentBorder}`,
          boxShadow:`0 3px 12px rgba(0,0,0,0.06)`,
          transition:"top 0.2s",
          padding:"8px 0",
        }}>
          <div style={{maxWidth:960,margin:"0 auto",width:"100%",boxSizing:"border-box"}}>
            {/* 上段：現在のカート名 + pt + 確認ボタン */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"6px 12px",gap:8}}>
              <div style={{fontWeight:600,fontSize:13,color:th.accent,letterSpacing:0.5,fontFamily:"'Noto Serif JP',serif",minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flex:1}}>
                {session.carts[activeCart]?.name}
                <span style={{fontWeight:400,fontSize:11,color:"#8a7060",marginLeft:6}}>を選択中</span>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
                <div style={{
                  background:overLimit?"#fdf0f0":th.ptBg,
                  border:`1px solid ${overLimit?"#e0b0b0":th.ptBorder}`,
                  color:overLimit?"#8b2020":th.ptColor,
                  borderRadius:1,padding:"3px 10px",fontWeight:600,fontSize:12,
                  whiteSpace:"nowrap",letterSpacing:0.5,fontFamily:"'Noto Sans JP',sans-serif"
                }}>{cartPoints}<span style={{fontSize:10,opacity:0.7}}>/{POINT_LIMIT}pt</span>{overLimit?" ⚠":""}</div>
                <button onClick={()=>setShowSummary(activeCart)} style={{
                  padding:"4px 12px",background:th.accent,color:"#fff",
                  border:"none",borderRadius:1,cursor:"pointer",fontSize:11,
                  letterSpacing:1,fontFamily:"'Noto Serif JP',serif",whiteSpace:"nowrap"
                }}>確認</button>
              </div>
            </div>
            {/* 下段：カート切替タブ（横スクロール） */}
            <div style={{display:"flex",gap:4,alignItems:"center",padding:"0 12px 6px",overflowX:"auto",scrollbarWidth:"none",WebkitOverflowScrolling:"touch"}}>
              {session.carts.map((c,i)=>{
                const pts=c.items.map(id=>menus.find(m=>m.id===id)).filter(Boolean).reduce((s,m)=>s+m.points,0);
                const over=pts>POINT_LIMIT;
                const isActive=i===activeCart;
                return (
                  <button key={i} onClick={()=>setActiveCart(i)} style={{
                    padding:"4px 12px",borderRadius:20,border:`1.5px solid ${over?"#c05050":isActive?th.accent:th.accentBorder}`,
                    flexShrink:0,fontSize:11,fontWeight:isActive?700:400,cursor:"pointer",whiteSpace:"nowrap",
                    letterSpacing:0.3,fontFamily:"'Noto Serif JP',serif",
                    background: isActive?th.accent:over?"#fdf0f0":"#f8f6f3",
                    color: isActive?"#fff":over?"#8b2020":th.accent,
                    transition:"all 0.15s",
                    boxShadow:isActive?`0 2px 8px ${th.accentLight}`:"none",
                  }}>
                    {i+1}. {c.name}{over?" ⚠":""}
                  </button>
                );
              })}
              <button onClick={()=>setShowAddCart(true)} style={{
                padding:"4px 10px",borderRadius:20,border:`1.5px dashed ${th.accentBorder}`,
                background:"transparent",color:th.accent,fontWeight:400,cursor:"pointer",
                fontSize:11,flexShrink:0,whiteSpace:"nowrap",letterSpacing:0.5,fontFamily:"'Noto Serif JP',serif"
              }}>＋</button>
            </div>
          </div>
        </div>

        {/* ── メインコンテンツ ── */}
        <div style={{maxWidth:960,margin:"0 auto",padding:`${totalFixedH+24}px 24px 40px`,transition:"padding-top 0.2s",position:"relative",zIndex:1}}>

          {/* 準備中メッセージ */}
          {isPreparing && (
            <div style={{
              textAlign:"center",padding:"48px 24px",
              background:"rgba(255,255,255,0.85)",
              border:`1px solid ${th.accentBorder}`,
              borderRadius:2,marginBottom:24,
            }}>
              <div style={{fontSize:28,marginBottom:16,opacity:0.6}}>{th.motif}</div>
              <div style={{fontSize:16,fontWeight:600,color:th.accent,letterSpacing:2,marginBottom:10,fontFamily:"'Noto Serif JP',serif"}}>
                現在準備中につき今しばらくお待ちくださいませ
              </div>
              <WaDivider color={th.accentBorder} style={{maxWidth:200,margin:"0 auto"}}/>
              <div style={{fontSize:12,color:"#8a7060",marginTop:12,letterSpacing:0.8,fontFamily:"'Noto Serif JP',serif"}}>
                <div>{session.season}のメニューは現在準備中です。</div>
                <div>施設スタッフにお声がけください。</div>
              </div>
            </div>
          )}

          {!isPreparing && (
            <div style={{marginBottom:20,padding:"14px 16px",background:"rgba(255,255,255,0.82)",border:"1px solid #e2d4be",borderRadius:2,fontFamily:"'Noto Serif JP',serif"}}>
              <p style={{fontSize:12,color:"#5a4030",letterSpacing:0.6,lineHeight:1.9,margin:0}}>
                持ち点100ptに収まるよう、下記よりお好きな料理をおひとりずつお選びください。<br/>
                【献立例】先付 ／ 前菜 ／ ＜下記で選択した料理＞ ／ 食事 ／ デザート
              </p>
              <p style={{fontSize:11,color:"#8a7060",letterSpacing:0.4,lineHeight:1.8,margin:"6px 0 0"}}>
                ※お選びいただいた料理は、通し番号の小さい順で提供いたします。
              </p>
            </div>
          )}

          {!isPreparing && overLimit && (
            <div style={{background:"#fdf0f0",border:"1px solid #e0b0b0",borderRadius:1,padding:"10px 16px",marginBottom:20,color:"#8b2020",fontSize:13,letterSpacing:0.5}}>
              ⚠ ポイント上限（{POINT_LIMIT}pt）を超えています
            </div>
          )}

          {!isPreparing && catGroups.map(({cat,items})=>(
            <div key={cat.id||"uncat"} style={{marginBottom:32}}>
              {/* カテゴリ見出し */}
              <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:14}}>
                <div style={{width:3,height:20,background:th.headerBg,borderRadius:2,flexShrink:0}}/>
                <div style={{fontSize:13,fontWeight:600,color:th.catLabel,letterSpacing:2,fontFamily:"'Noto Serif JP',serif"}}>{cat.name}</div>
                <div style={{flex:1,height:1,background:`linear-gradient(90deg,${th.accentBorder},transparent)`}}/>
              </div>

              {/* 料理カードグリッド */}
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(min(280px,100%),1fr))",gap:16}}>
                {items.map(m=>{
                  const selected=cart.items.includes(m.id);
                  const outOfPeriod = isOutOfPeriod(m, session.date);
                  const isHidden = !!m.hidden;
                  const unavailable = outOfPeriod || isHidden;
                  return (
                    <div key={m.id}
                      onClick={()=>{ if(unavailable) return; selected?removeItem(m.id):addItem(m.id); }}
                      style={{
                        borderRadius:2,overflow:"hidden",
                        cursor:unavailable?"default":"pointer",
                        border:`2px solid ${unavailable?"#d1d5db":selected?th.accent:th.cardBorder}`,
                        boxShadow: unavailable
                          ?"none"
                          :selected
                            ?`0 6px 28px rgba(0,0,0,0.18),0 0 0 3px ${th.accentLight}`
                            :"0 2px 10px rgba(0,0,0,0.06)",
                        background: unavailable?"#f5f5f5":selected?th.cardSelected:th.cardBg,
                        opacity: unavailable?0.65:selected?1:0.78,
                        transform: (!unavailable&&selected)?"translateY(-2px)":"none",
                        transition:"all 0.2s",
                        display:"flex",flexDirection:"column",
                        position:"relative",
                      }}
                      onMouseEnter={e=>{ if(!selected&&!unavailable){ e.currentTarget.style.opacity="1"; e.currentTarget.style.boxShadow="0 6px 24px rgba(0,0,0,0.1)"; } }}
                      onMouseLeave={e=>{ if(!selected&&!unavailable){ e.currentTarget.style.opacity="0.78"; e.currentTarget.style.boxShadow="0 2px 10px rgba(0,0,0,0.06)"; } }}
                    >
                      {/* 選択時の上部アクセントライン / 利用不可時はグレー */}
                      {unavailable
                        ? <div style={{height:3,background:"#c8c8c8",flexShrink:0}}/>
                        : selected && <div style={{height:3,background:th.headerBg,flexShrink:0}}/>
                      }

                      {/* 写真エリア */}
                      <div style={{width:"100%",height:170,overflow:"hidden",position:"relative",flexShrink:0}}>
                        {m.img ? (
                          <img src={m.img} alt={m.name}
                            style={{width:"100%",height:"100%",objectFit:"cover",display:"block",
                              transition:"transform 0.3s",
                              filter:unavailable?"grayscale(80%) brightness(0.85)":selected?"none":"grayscale(15%) brightness(0.95)"}}
                            onMouseEnter={e=>{ if(!unavailable) e.target.style.transform="scale(1.03)"; }}
                            onMouseLeave={e=>e.target.style.transform="scale(1)"}
                          />
                        ) : (
                          <div style={{width:"100%",height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",
                            background:unavailable?"#e8e8e8":th.noImgBg}}>
                            <div style={{fontSize:36,marginBottom:6,opacity:0.5}}>🍽️</div>
                            <div style={{fontSize:10,letterSpacing:2,color:unavailable?"#aaa":th.noImgText,fontFamily:"'Noto Serif JP',serif"}}>お料理の写真</div>
                          </div>
                        )}

                        {/* 利用不可オーバーレイ */}
                        {unavailable && (
                          <div style={{position:"absolute",inset:0,background:"rgba(200,200,200,0.35)",display:"flex",alignItems:"center",justifyContent:"center"}}>
                            <div style={{background:"rgba(60,60,60,0.82)",color:"#fff",fontSize:10,padding:"5px 10px",
                              borderRadius:2,textAlign:"center",lineHeight:1.6,letterSpacing:0.5,maxWidth:"80%",
                              fontFamily:"'Noto Serif JP',serif"}}>
                              {isHidden?"仕入状況によりご選択いただけません":"提供期間外のためご選択いただけません"}
                            </div>
                          </div>
                        )}

                        {/* 選択チェック（利用可能時のみ） */}
                        {!unavailable && (selected ? (
                          <div style={{position:"absolute",top:10,right:10,background:th.accent,color:"#fff",borderRadius:"50%",width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,fontWeight:700,boxShadow:"0 2px 10px rgba(0,0,0,0.3)"}}>✓</div>
                        ) : (
                          <div style={{position:"absolute",top:10,right:10,width:26,height:26,borderRadius:"50%",border:"1.5px solid rgba(255,255,255,0.7)",background:"rgba(255,255,255,0.2)"}}/>
                        ))}

                        {/* No.バッジ */}
                        <div style={{position:"absolute",bottom:0,left:0,background:"rgba(0,0,0,0.45)",color:"rgba(255,255,255,0.9)",fontSize:10,padding:"3px 8px",letterSpacing:0.5,fontFamily:"'Noto Sans JP',sans-serif"}}>
                          No.{m.no}
                        </div>
                      </div>

                      {/* 情報エリア */}
                      <div style={{padding:"12px 14px",display:"flex",flexDirection:"column",gap:5,flex:1}}>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                          <div style={{fontSize:14,fontWeight:(!unavailable&&selected)?700:600,
                            color:unavailable?"#888":selected?th.accent:"#2a1a0e",
                            lineHeight:1.4,flex:1,fontFamily:"'Noto Serif JP',serif"}}>{m.name}</div>
                          <div style={{
                            whiteSpace:"nowrap",letterSpacing:0.5,fontFamily:"'Noto Sans JP',sans-serif",
                            background:unavailable?"#e0e0e0":selected?th.accent:th.ptBg,
                            color:unavailable?"#999":selected?"#fff":th.ptColor,
                            padding:"2px 8px",borderRadius:1,flexShrink:0,
                            border:`1px solid ${unavailable?"#ccc":selected?th.accent:th.ptBorder}`,
                            fontSize:12,fontWeight:700
                          }}>{m.points}pt</div>
                        </div>
                        {m.allergens&&m.allergens!=="なし"&&(
                          <div style={{fontSize:10,color:unavailable?"#999":"#7a5000",
                            background:unavailable?"#f0f0f0":"#fdf3e0",
                            border:`1px solid ${unavailable?"#ddd":"#e8d4a0"}`,
                            borderRadius:1,padding:"2px 6px",display:"inline-block",alignSelf:"flex-start",letterSpacing:0.3}}>
                            {m.allergens}
                          </div>
                        )}
                        {/* 提供期間の表示 */}
                        {(m.start||m.end) && (
                          <div style={{fontSize:10,color:unavailable?"#aaa":th.noImgText,letterSpacing:0.3,fontFamily:"'Noto Sans JP',sans-serif"}}>
                            提供期間：{m.start}〜{m.end}
                          </div>
                        )}
                        {m.note&&<div style={{fontSize:10,color:unavailable?"#aaa":"#8a7060",lineHeight:1.6,letterSpacing:0.3,fontFamily:"'Noto Sans JP',sans-serif"}}>{m.note}</div>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          {/* 保存ボタン */}
          {!isPreparing && (
            <div style={{textAlign:"center",marginTop:16,paddingBottom:20}}>
              <WaDivider color={th.accentBorder} style={{marginBottom:24}}/>
              <button
                onClick={handleSave}
                disabled={anyOver}
                style={{
                  padding:"13px 48px",background:anyOver?"#ccc":th.saveBg,
                  color:anyOver?"#999":"#fff",border:"none",borderRadius:1,cursor:anyOver?"not-allowed":"pointer",
                  fontSize:13,fontWeight:500,letterSpacing:2,fontFamily:"'Noto Serif JP',serif",
                  boxShadow:anyOver?"none":"0 4px 20px rgba(0,0,0,0.15)",
                }}
                onMouseEnter={e=>{ if(!anyOver) e.currentTarget.style.opacity="0.85"; }}
                onMouseLeave={e=>{ e.currentTarget.style.opacity="1"; }}
              >{saved?"✓ 保存済み":"保存する"}</button>
              <div style={{marginTop:8,fontSize:11,letterSpacing:0.5,fontFamily:"'Noto Serif JP',serif",color:"#8a7060"}}>最新データが施設に送信されます</div>
              {anyOver && (
                <div style={{color:"#8b2020",marginTop:6,fontSize:12,letterSpacing:0.5}}>⚠ ポイント超過のカートがあるため保存できません</div>
              )}
            </div>
          )}
        </div>

        {/* カート追加モーダル */}
        {showAddCart && (
          <Modal title="カートを追加" onClose={()=>setShowAddCart(false)} season={session.season}>
            <Input season={session.season} label="お名前" value={newCartName} onChange={setNewCartName} placeholder="例：山田 花子" autoFocus
              onKeyDown={e=>{ if(e.key==="Enter"&&newCartName.trim()) handleAddCart(); }}/>
            <div style={{display:"flex",gap:10}}>
              <Btn season={session.season} onClick={handleAddCart} disabled={!newCartName.trim()} style={{flex:1}} color="success">追加する</Btn>
              <Btn season={session.season} color="gray" onClick={()=>setShowAddCart(false)} style={{flex:1}}>キャンセル</Btn>
            </div>
          </Modal>
        )}

        {/* メニュー一覧モーダル */}
        {showMenuList && (
          <Modal title={`${session.season}のメニュー一覧`} onClose={()=>setShowMenuList(false)} season={session.season}>
            <div style={{maxHeight:420,overflowY:"auto"}}>
              {catGroups.map(({cat,items})=>(
                <div key={cat.id||"uncat"} style={{marginBottom:18}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                    <div style={{width:3,height:14,background:th.headerBg,borderRadius:1,flexShrink:0}}/>
                    <div style={{fontWeight:600,fontSize:12,color:th.catLabel,letterSpacing:1.5}}>{cat.name}</div>
                  </div>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                    <tbody>
                      {items.map(m=>(
                        <tr key={m.id} style={{borderBottom:`1px solid ${th.accentLight}`}}>
                          <td style={{padding:"6px 8px",color:th.noImgText,width:36,fontFamily:"'Noto Sans JP',sans-serif",fontSize:11}}>{m.no}</td>
                          <td style={{padding:"6px 8px",fontWeight:500,color:"#2a1a0e"}}>{m.name}</td>
                          <td style={{padding:"6px 8px",textAlign:"right",fontWeight:600,color:th.ptColor,fontFamily:"'Noto Sans JP',sans-serif",whiteSpace:"nowrap"}}>{m.points}pt</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          </Modal>
        )}

        {/* 選択確認モーダル */}
        {showSummary!==null && <SummaryModal
          cart={session.carts[showSummary]}
          menus={menus}
          catGroups={catGroups}
          th={th}
          onClose={()=>setShowSummary(null)}
          season={session.season}
        />}
      </div>
    </>
  );
}

// ─── 注文データ アコーディオン（OrderAccordion）─────────────────────────────
function OrderAccordion({orderList, orders, saveOrders, menus, categories, expandedOrder, setExpandedOrder, expandedCart, setExpandedCart, setDeleteOrderTarget}){
  const [editingCart,setEditingCart]=useState(null);
  const [editItems,setEditItems]=useState([]);
  const [toast,setToast]=useState("");
  const toastTimer=useRef(null);
  function showToast(msg){
    setToast(msg);
    if(toastTimer.current) clearTimeout(toastTimer.current);
    toastTimer.current=setTimeout(()=>setToast(""),2500);
  }
  function copyText(text){
    try{
      const ta=document.createElement("textarea");
      ta.value=text;
      ta.style.position="fixed";
      ta.style.opacity="0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok=document.execCommand("copy");
      document.body.removeChild(ta);
      if(ok){ showToast("テキストをコピーしました"); }
      else{ showToast("コピーできませんでした"); }
    }catch(e){ showToast("コピーできませんでした"); }
  }

  function startEditCart(o, c){
    const ck=o.reservationNo+"__"+c.name;
    setEditingCart(ck);
    setEditItems([...c.items]);
    setExpandedCart(ck);
  }
  function toggleEditItem(menuId){
    setEditItems(prev=>{
      const idx=prev.indexOf(menuId);
      if(idx>=0){ const n=[...prev]; n.splice(idx,1); return n; }
      return [...prev, menuId];
    });
  }
  async function saveEditCart(o, c){
    const newCarts=o.carts.map(x=>x.name===c.name?{...x,items:editItems}:x);
    const ts=new Date().toISOString();
    const updated={...orders,[o.reservationNo]:{...o,carts:newCarts,updatedAt:ts,updatedBy:"admin"}};
    await saveOrders(updated);
    setEditingCart(null);
    setEditItems([]);
  }
  function cancelEditCart(){
    setEditingCart(null);
    setEditItems([]);
  }

  return (
    <div style={{position:"relative"}}>
      {toast && (
        <div style={{
          position:"fixed",bottom:32,left:"50%",transform:"translateX(-50%)",
          background:"#1e293b",color:"#fff",padding:"10px 24px",borderRadius:24,
          fontSize:14,fontWeight:600,letterSpacing:0.5,zIndex:9999,
          boxShadow:"0 4px 20px rgba(0,0,0,0.3)",pointerEvents:"none",
          animation:"fadeIn 0.2s ease"
        }}>
          ✅ {toast}
        </div>
      )}
      {orderList.map(o=>{
        const isExp=expandedOrder===o.reservationNo;
        const displayDate=fmtDate(o.date);
        const seasonMenuList=withNos(menus.filter(m=>m.season===o.season));
        // スナップショットからメニュー情報を復元するヘルパー
        function resolveItem(cartObj, id){
          if(cartObj.itemSnapshots){
            const snap=cartObj.itemSnapshots.find(s=>s.id===id);
            if(snap&&snap.name) return snap;
          }
          return seasonMenuList.find(m=>m.id===id)||null;
        }
        const sortedCatsLocal=[...categories].sort((a,b)=>a.order-b.order);
        return (
          <div key={o.reservationNo} style={{marginBottom:8,border:"1.5px solid #e2e8f0",borderRadius:12,overflow:"hidden"}}>
            <div onClick={()=>{setExpandedOrder(isExp?null:o.reservationNo);setExpandedCart(null);setEditingCart(null);}}
              style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 18px",cursor:"pointer",background:isExp?"#eff6ff":"#fff",userSelect:"none"}}>
              <div style={{display:"flex",gap:16,flexWrap:"wrap",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#2563eb",minWidth:100}}>{o.reservationNo}</span>
                <span style={{color:"#374151",minWidth:90}}>{displayDate}</span>
                <span style={{fontWeight:600}}>{o.representative}</span>
                <span style={{fontSize:13,color:"#64748b"}}>{SEASON_EMOJI[o.season]}{o.season} ／ {o.carts.length}名分</span>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
                <span style={{fontSize:11,color:"#94a3b8"}}>更新：{fmtDt(o.updatedAt)}{o.updatedBy==="admin"?" （管理者）":o.updatedBy==="user"?" （ユーザー）":""}</span>
                <button
                  onClick={e=>{ e.stopPropagation(); setDeleteOrderTarget(o); }}
                  style={{background:"#fef2f2",border:"1.5px solid #fca5a5",color:"#dc2626",borderRadius:6,padding:"4px 10px",cursor:"pointer",fontWeight:600,fontSize:12,flexShrink:0}}>
                  🗑️ 削除
                </button>
                <span style={{fontSize:18,color:"#94a3b8"}}>{isExp?"▲":"▼"}</span>
              </div>
            </div>
            {isExp && (
              <div style={{background:"#f8fafc",borderTop:"1px solid #e2e8f0",padding:"12px 18px"}}>
                {o.carts.map(c=>{
                  const ck=o.reservationNo+"__"+c.name;
                  const isCartOpen=expandedCart===ck;
                  const isEditing=editingCart===ck;
                  const displayItems=isEditing?editItems:c.items;
                  const resolvedItems=displayItems.map(id=>resolveItem(c,id)).filter(Boolean).sort((a,b)=>Number(a.no)-Number(b.no));
                  const total=resolvedItems.reduce((s,m)=>s+m.points,0);
                  const overLimit=total>POINT_LIMIT;
                  return (
                    <div key={ck} style={{marginBottom:8,border:"1.5px solid "+(isEditing?"#f59e0b":"#e2e8f0"),borderRadius:10,overflow:"hidden",background:"#fff"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",background:isEditing?"#fffbeb":isCartOpen?"#f0fdf4":"#fff"}}>
                        <div
                          onClick={()=>{ if(!isEditing) setExpandedCart(isCartOpen?null:ck); }}
                          style={{display:"flex",gap:12,alignItems:"center",cursor:isEditing?"default":"pointer",flex:1,userSelect:"none"}}>
                          <span style={{fontWeight:700}}>🛒 {c.name}</span>
                          <span style={{fontSize:13,color:"#64748b"}}>{resolvedItems.length}品</span>
                          {isEditing && <span style={{fontSize:11,color:"#92400e",background:"#fef3c7",padding:"2px 8px",borderRadius:10,fontWeight:600}}>✏️ 修正中</span>}
                        </div>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          <span style={{fontWeight:700,color:overLimit?"#dc2626":"#2563eb"}}>{total}pt{overLimit?" ⚠":""}</span>
                          {isEditing ? (
                            <>
                              <button
                                onClick={()=>saveEditCart(o,c)}
                                disabled={overLimit}
                                style={{background:overLimit?"#d1d5db":"#16a34a",color:overLimit?"#9ca3af":"#fff",border:"none",borderRadius:6,padding:"5px 12px",cursor:overLimit?"not-allowed":"pointer",fontWeight:700,fontSize:12}}>
                                保存
                              </button>
                              <button
                                onClick={cancelEditCart}
                                style={{background:"#f1f5f9",color:"#64748b",border:"1px solid #e2e8f0",borderRadius:6,padding:"5px 12px",cursor:"pointer",fontSize:12}}>
                                キャンセル
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                onClick={e=>{
                                  e.stopPropagation();
                                  const sorted=c.items.map(id=>resolveItem(c,id)).filter(Boolean).sort((a,b)=>Number(a.no)-Number(b.no));
                                  const ptSum=sorted.reduce((s,m)=>s+m.points,0);
                                  const menuStr=sorted.map(m=>m.no+"."+m.name).join("／");
                                  copyText("【"+c.name+"】＜"+ptSum+"pt＞"+menuStr);
                                }}
                                style={{background:"#eff6ff",color:"#1d4ed8",border:"1.5px solid #bfdbfe",borderRadius:6,padding:"4px 10px",cursor:"pointer",fontWeight:600,fontSize:12,whiteSpace:"nowrap"}}>
                                📋 テキストコピー
                              </button>
                              <button
                                onClick={e=>{ e.stopPropagation(); startEditCart(o,c); }}
                                style={{background:"#fffbeb",color:"#92400e",border:"1.5px solid #fcd34d",borderRadius:6,padding:"4px 10px",cursor:"pointer",fontWeight:600,fontSize:12}}>
                                ✏️ 修正
                              </button>
                              <span onClick={()=>setExpandedCart(isCartOpen?null:ck)} style={{fontSize:16,color:"#94a3b8",cursor:"pointer"}}>{isCartOpen?"▲":"▼"}</span>
                            </>
                          )}
                        </div>
                      </div>
                      {(isCartOpen||isEditing) && (
                        <div style={{borderTop:"1px solid #f1f5f9",padding:"8px 16px"}}>
                          {isEditing ? (
                            <div>
                              {overLimit && (
                                <div style={{background:"#fef2f2",border:"1px solid #fca5a5",borderRadius:6,padding:"6px 12px",marginBottom:8,fontSize:12,color:"#dc2626",fontWeight:600}}>
                                  ⚠ {POINT_LIMIT}ptを超えています。超過している場合は保存できません。
                                </div>
                              )}
                              {[...sortedCatsLocal,{id:null,name:"その他"}].map(cat=>{
                                const catMenus=seasonMenuList.filter(m=>
                                  cat.id===null
                                    ?(!m.categoryId||m.categoryId==="null")
                                    :String(m.categoryId)===String(cat.id)
                                );
                                if(catMenus.length===0) return null;
                                return (
                                  <div key={cat.id||"uncat"} style={{marginBottom:10}}>
                                    <div style={{fontSize:11,fontWeight:700,color:"#475569",letterSpacing:1,marginBottom:4,paddingBottom:2,borderBottom:"1px solid #e2e8f0"}}>{cat.name}</div>
                                    {catMenus.map(m=>{
                                      const checked=editItems.includes(m.id);
                                      return (
                                        <div key={m.id}
                                          onClick={()=>toggleEditItem(m.id)}
                                          style={{display:"flex",alignItems:"center",gap:8,padding:"5px 4px",cursor:"pointer",borderRadius:4,background:checked?"#eff6ff":"transparent"}}>
                                          <div style={{width:16,height:16,borderRadius:3,border:"1.5px solid "+(checked?"#2563eb":"#d1d5db"),background:checked?"#2563eb":"#fff",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                                            {checked && <span style={{color:"#fff",fontSize:11,fontWeight:800,lineHeight:1}}>✓</span>}
                                          </div>
                                          <span style={{fontSize:12,color:"#64748b",width:28,flexShrink:0}}>No.{m.no}</span>
                                          <span style={{fontSize:13,fontWeight:checked?700:400,flex:1,color:checked?"#1e40af":"#374151"}}>{m.name}</span>
                                          <span style={{fontSize:12,fontWeight:600,color:"#2563eb",flexShrink:0}}>{m.points}pt</span>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            resolvedItems.length===0 ? <p style={{color:"#94a3b8",margin:"8px 0",fontSize:13}}>未選択</p> : (
                              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                                <thead><tr style={{background:"#f8fafc"}}>
                                  <th style={{padding:"6px 8px",textAlign:"left",borderBottom:"1px solid #e2e8f0"}}>No.</th>
                                  <th style={{padding:"6px 8px",textAlign:"left",borderBottom:"1px solid #e2e8f0"}}>メニュー名</th>
                                  <th style={{padding:"6px 8px",textAlign:"right",borderBottom:"1px solid #e2e8f0"}}>ポイント</th>
                                </tr></thead>
                                <tbody>
                                  {resolvedItems.map((m,i)=>(
                                    <tr key={i} style={{borderBottom:"1px solid #f8fafc"}}>
                                      <td style={{padding:"6px 8px",color:"#94a3b8"}}>{m.no}</td>
                                      <td style={{padding:"6px 8px",fontWeight:600}}>{m.name}</td>
                                      <td style={{padding:"6px 8px",textAlign:"right",color:"#2563eb",fontWeight:700}}>{m.points}pt</td>
                                    </tr>
                                  ))}
                                  <tr style={{background:"#f0fdf4"}}>
                                    <td colSpan={2} style={{padding:"6px 8px",fontWeight:800}}>合計</td>
                                    <td style={{padding:"6px 8px",textAlign:"right",fontWeight:800,color:"#16a34a"}}>{total}pt</td>
                                  </tr>
                                </tbody>
                              </table>
                            )
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ─── 選択確認モーダル（CartScreen内のIIFEを分離） ──────────────────────────────
function SummaryModal({cart,menus,catGroups,th,onClose,season}){
  const allItems=cart.items.map(id=>menus.find(m=>m.id===id)).filter(Boolean).sort((a,b)=>Number(a.no)-Number(b.no));
  const total=allItems.reduce((s,m)=>s+m.points,0);
  const summaryGroups=catGroups.map(({cat,items:ci})=>({
    cat,
    items:ci.filter(m=>allItems.some(a=>a.id===m.id))
  })).filter(g=>g.items.length>0);
  return (
    <Modal title={cart.name+" — ご選択内容"} onClose={onClose} season={season}>
      {allItems.length===0 ? (
        <p style={{color:"#b09070",textAlign:"center",fontSize:13,letterSpacing:1,padding:"16px 0"}}>まだ選択されていません</p>
      ) : (
        <>
          {summaryGroups.map(({cat,items})=>(
            <div key={cat.id||"uncat"} style={{marginBottom:18}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                <div style={{width:3,height:14,background:th.headerBg,borderRadius:1,flexShrink:0}}/>
                <div style={{fontWeight:600,fontSize:12,color:th.catLabel,letterSpacing:1.5}}>{cat.name}</div>
              </div>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                <tbody>
                  {items.map((m,i)=>(
                    <tr key={i} style={{borderBottom:"1px solid "+th.accentLight}}>
                      <td style={{padding:"7px 8px",color:th.noImgText,width:34,fontSize:11,fontFamily:"'Noto Sans JP',sans-serif"}}>{m.no}</td>
                      <td style={{padding:"7px 8px",fontWeight:500,color:"#2a1a0e"}}>{m.name}</td>
                      <td style={{padding:"7px 8px",textAlign:"right",fontWeight:600,color:th.ptColor,fontFamily:"'Noto Sans JP',sans-serif",whiteSpace:"nowrap"}}>{m.points}pt</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
          <WaDivider color={th.accentBorder} style={{margin:"12px 0 10px"}}/>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"4px 8px"}}>
            <span style={{fontWeight:600,fontSize:14,color:"#2a1a0e",letterSpacing:1}}>合　計</span>
            <span style={{fontWeight:700,fontSize:16,color:th.ptColor,fontFamily:"'Noto Sans JP',sans-serif"}}>
              {total}<span style={{fontSize:11,opacity:0.7}}>/{POINT_LIMIT}pt</span>
            </span>
          </div>
        </>
      )}
    </Modal>
  );
}

// 管理画面
function AdminScreen({menus,saveMenus,categories,saveCategories,orders,saveOrders,seasonStatus,saveSeasonStatus,siteConfig,saveSiteConfig,menuHistory,saveMenuHistory,onBack,authed,setAuthed}){
  const [adminId,setAdminId]=useState("");
  const [pw,setPw]=useState("");
  const [operatorName,setOperatorName]=useState(()=>{
    try{ return sessionStorage.getItem("ss_operator")||""; }catch{ return ""; }
  });
  const [operatorInput,setOperatorInput]=useState("");
  const [tab,setTab]=useState("orders");
  const [historyPage,setHistoryPage]=useState(0);
  const HISTORY_PER_PAGE=20;
  const [editMenu,setEditMenu]=useState(null);
  const [newMenu,setNewMenu]=useState(null);
  const [bulkCopyModal,setBulkCopyModal]=useState(false);
  const [bulkCopyTo,setBulkCopyTo]=useState("夏");
  const [bulkCopyDates,setBulkCopyDates]=useState({start:"",end:""});
  const [seasonTab,setSeasonTab]=useState("春");
  const [deleteTarget,setDeleteTarget]=useState(null);
  const [expandedOrder,setExpandedOrder]=useState(null);
  const [expandedCart,setExpandedCart]=useState(null);
  const [pastSearch,setPastSearch]=useState("");
  const [showPast,setShowPast]=useState(false);
  const [menuDragList,setMenuDragList]=useState(null);
  const [menuDirty,setMenuDirty]=useState(false);
  const [catDragList,setCatDragList]=useState(null);
  const [catDirty,setCatDirty]=useState(false);
  const [editCat,setEditCat]=useState(null);
  const [newCatName,setNewCatName]=useState("");
  const [deleteCatTarget,setDeleteCatTarget]=useState(null);
  const [deleteOrderTarget,setDeleteOrderTarget]=useState(null);

  const dragSrc=useRef(null);
  const catDragIdx=useRef(null);

  useEffect(()=>{setMenuDragList(null);setMenuDirty(false);},[seasonTab]);

  function handleLogin(){
    if(adminId===ADMIN_ID && pw===ADMIN_PASSWORD){
      if(!operatorInput.trim()){ alert("担当者名を入力してください"); return; }
      const name=operatorInput.trim();
      setOperatorName(name);
      try{ sessionStorage.setItem("ss_operator",name); }catch{}
      setAuthed(true);
    }
    else if(adminId!==ADMIN_ID){ alert("IDが違います"); }
    else{ alert("パスワードが違います"); }
  }

  if(!authed) return (
    <div style={{minHeight:"100vh",background:"#1e293b",display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{background:"#fff",borderRadius:20,padding:36,maxWidth:380,width:"90%",boxShadow:"0 10px 40px rgba(0,0,0,0.3)"}}>
        <div style={{textAlign:"center",marginBottom:24}}>
          <div style={{fontSize:40}}>🔐</div>
          <h2 style={{margin:"8px 0 0",fontWeight:800}}>管理画面ログイン</h2>
        </div>
        <div style={{marginBottom:16}}>
          <label style={{display:"block",fontWeight:600,marginBottom:6,color:"#374151",fontSize:14}}>管理者ID</label>
          <input type="text" value={adminId} onChange={e=>setAdminId(e.target.value)}
            placeholder="IDを入力" autoFocus
            onKeyDown={e=>{ if(e.key==="Enter") document.getElementById("admin-pw-input").focus(); }}
            style={{width:"100%",padding:"10px 14px",border:"1.5px solid #d1d5db",borderRadius:8,fontSize:15,boxSizing:"border-box",outline:"none"}}/>
        </div>
        <div style={{marginBottom:16}}>
          <label style={{display:"block",fontWeight:600,marginBottom:6,color:"#374151",fontSize:14}}>パスワード</label>
          <input id="admin-pw-input" type="password" value={pw} onChange={e=>setPw(e.target.value)}
            placeholder="パスワードを入力"
            onKeyDown={e=>{ if(e.key==="Enter") document.getElementById("admin-operator-input").focus(); }}
            style={{width:"100%",padding:"10px 14px",border:"1.5px solid #d1d5db",borderRadius:8,fontSize:15,boxSizing:"border-box",outline:"none"}}/>
        </div>
        <div style={{marginBottom:20}}>
          <label style={{display:"block",fontWeight:600,marginBottom:6,color:"#374151",fontSize:14}}>担当者名</label>
          <input id="admin-operator-input" type="text" value={operatorInput} onChange={e=>setOperatorInput(e.target.value)}
            placeholder="例：山田"
            onKeyDown={e=>{ if(e.key==="Enter") handleLogin(); }}
            style={{width:"100%",padding:"10px 14px",border:"1.5px solid #d1d5db",borderRadius:8,fontSize:15,boxSizing:"border-box",outline:"none"}}/>
          <div style={{fontSize:11,color:"#94a3b8",marginTop:4}}>変更履歴に記録されます</div>
        </div>
        <button onClick={handleLogin}
          style={{width:"100%",padding:"11px",background:"#1e293b",color:"#fff",border:"none",borderRadius:8,fontSize:15,fontWeight:600,cursor:"pointer"}}>ログイン</button>
        <div style={{textAlign:"center",marginTop:12}}>
          <button onClick={onBack} style={{background:"none",border:"none",color:"#94a3b8",cursor:"pointer",fontSize:14}}>← 戻る</button>
        </div>
      </div>
    </div>
  );

  const sortedCats=[...(catDragList||categories)].sort((a,b)=>a.order-b.order);
  const displayCats=[...sortedCats,{id:null,name:"未分類",order:9999}];
  const baseSeasonMenus=withNos(menus.filter(m=>m.season===seasonTab));
  const displayMenus=menuDragList||baseSeasonMenus;

  function getGroupMenus(catId){
    return displayMenus.filter(m=>catId===null?(!m.categoryId||m.categoryId==="null"):String(m.categoryId)===String(catId));
  }

  function onCatDragStart(i){ catDragIdx.current=i; }
  function onCatDragEnter(i){
    if(catDragIdx.current===null||catDragIdx.current===i) return;
    const base=[...(catDragList||sortedCats)];
    const [moved]=base.splice(catDragIdx.current,1);
    base.splice(i,0,moved);
    setCatDragList(base.map((c,idx)=>({...c,order:idx+1})));
    catDragIdx.current=i; setCatDirty(true);
  }
  async function handleSaveCatOrder(){ await saveCategories(catDragList); setCatDragList(null); setCatDirty(false); alert("✅ カテゴリの並び順を保存しました"); }

  function onMenuDragStart(menuId){ dragSrc.current=menuId; }
  function onMenuDrop(e,tgtMenuId,tgtCatId){
    e.preventDefault();
    if(!dragSrc.current) return;
    const srcId=dragSrc.current;
    const base=[...(menuDragList||baseSeasonMenus)];
    const srcIdx=base.findIndex(m=>m.id===srcId);
    if(srcIdx===-1){ dragSrc.current=null; return; }
    const tgtCatOrder=tgtCatId===null?999:(sortedCats.find(c=>c.id===tgtCatId)?.order||999);
    const moved={...base[srcIdx],categoryId:tgtCatId,catOrder:tgtCatOrder};
    base.splice(srcIdx,1);
    if(tgtMenuId===null){ base.push(moved); }
    else { const ti=base.findIndex(m=>m.id===tgtMenuId); base.splice(ti>=0?ti:base.length,0,moved); }
    const catCounts={};
    const reordered=base.map(m=>{ const k=m.season+"|"+(m.categoryId||"null"); catCounts[k]=(catCounts[k]||0)+1; return {...m,order:catCounts[k]}; });
    setMenuDragList(reordered); setMenuDirty(true); dragSrc.current=null;
  }
  function onMenuDragOver(e){ e.preventDefault(); }

  async function handleSaveMenuOrder(){
    if(!menuDragList) return;
    const others=menus.filter(m=>m.season!==seasonTab);
    const newMenus=withNos([...others,...menuDragList]);
    // 並び替え前後の順番をまとめて1件の履歴として記録
    const beforeOrder=menus.filter(m=>m.season===seasonTab).map(m=>m.name);
    const afterOrder=menuDragList.map(m=>m.name);
    const orderChanged=beforeOrder.some((n,i)=>n!==afterOrder[i]);
    if(orderChanged){
      const entry={
        id:Date.now(),
        action:"並び替え",
        operator:operatorName||"不明",
        before:{season:seasonTab, order:beforeOrder},
        after:{season:seasonTab, order:afterOrder},
        timestamp:new Date().toISOString(),
        device:getDeviceInfo(),
      };
      const updated=[entry,...(menuHistory||[])].slice(0,200);
      saveMenuHistory(updated);
    }
    await saveMenus(newMenus);
    setMenuDragList(null); setMenuDirty(false); alert("✅ 並び順を保存しました");
  }

  function getDeviceInfo(){
    const ua=navigator.userAgent;
    if(/iPhone/.test(ua)) return "iPhone";
    if(/iPad/.test(ua)) return "iPad";
    if(/Android/.test(ua)) return "Android";
    if(/Mac/.test(ua)) return "Mac";
    if(/Windows/.test(ua)) return "Windows";
    return "不明な端末";
  }
  function addHistory(action, before, after){
    const entry={
      id:Date.now(),
      action,
      operator:operatorName||"不明",
      before: before?{id:before.id,name:before.name,season:before.season,points:before.points,desc:before.desc||"",img:before.img?"(画像あり)":"(画像なし)",hidden:before.hidden||false}:null,
      after: after?{id:after.id,name:after.name,season:after.season,points:after.points,desc:after.desc||"",img:after.img?"(画像あり)":"(画像なし)",hidden:after.hidden||false}:null,
      timestamp:new Date().toISOString(),
      device:getDeviceInfo(),
    };
    const updated=[entry,...(menuHistory||[])].slice(0,200);
    saveMenuHistory(updated);
  }
  function handleSaveMenu(m){
    const isNew=!m.id;
    const before=isNew?null:menus.find(x=>x.id===m.id)||null;
    const updated=isNew?[...menus,{...m,id:Date.now(),order:(menus.filter(x=>x.season===m.season).length+1),catOrder:999,categoryId:null}]:menus.map(x=>x.id===m.id?m:x);
    const after=isNew?{...m,id:Date.now()}:m;
    addHistory(isNew?"追加":"編集", before, after);
    saveMenus(withNos(updated)); setEditMenu(null); setNewMenu(null); setMenuDragList(null); setMenuDirty(false);
  }
  async function handleDeleteMenu(targetId){
    const before=menus.find(x=>String(x.id)===String(targetId))||null;
    addHistory("削除", before, null);
    await saveMenus(withNos(menus.filter(x=>String(x.id)!==String(targetId))));
    setDeleteTarget(null); setMenuDragList(null); setMenuDirty(false);
  }
  async function handleBulkCopy(){
    const src=menus.filter(m=>m.season===seasonTab);
    if(src.length===0){ alert("コピー元のメニューがありません"); return; }
    const now=Date.now();
    const copies=src.map((m,i)=>({
      ...m,
      id:now+i,
      season:bulkCopyTo,
      start:bulkCopyDates.start||SEASON_DATES[bulkCopyTo].start,
      end:bulkCopyDates.end||SEASON_DATES[bulkCopyTo].end,
      order:(menus.filter(x=>x.season===bulkCopyTo).length+i+1),
    }));
    await saveMenus(withNos([...menus,...copies]));
    setBulkCopyModal(false);
    alert(bulkCopyTo+"に"+copies.length+"件コピーしました");
  }
  function handleSaveCat(){
    if(!newCatName) return;
    saveCategories([...categories,{id:"cat"+Date.now(),name:newCatName,order:categories.length+1}]);
    setNewCatName("");
  }
  async function handleDeleteCat(catId){
    await saveMenus(menus.map(m=>m.categoryId===catId?{...m,categoryId:null,catOrder:999}:m));
    await saveCategories(categories.filter(c=>c.id!==catId));
    setDeleteCatTarget(null);
  }

  async function handleDeleteOrder(reservationNo){
    const updated={...orders};
    delete updated[reservationNo];
    await saveOrders(updated);
    setDeleteOrderTarget(null);
    if(expandedOrder===reservationNo) setExpandedOrder(null);
  }

  const allOrders=Object.values(orders).sort((a,b)=>new Date(a.date)-new Date(b.date));
  const activeOrders=allOrders.filter(o=>!isPast(o.date));
  const pastOrders=allOrders.filter(o=>isPast(o.date));
  // E: スラッシュ検索対応
  const kw=pastSearch.trim().toLowerCase();
  const filteredPast=kw?pastOrders.filter(o=>{
    const dateStr=fmtDate(o.date); // yyyy/mm/dd形式に変換して検索
    return o.reservationNo.toLowerCase().includes(kw)||dateStr.includes(kw)||(o.representative||"").toLowerCase().includes(kw);
  }):pastOrders;
  const emptyMenu={name:"",points:10,season:seasonTab,allergens:"",img:"",note:"",...SEASON_DATES[seasonTab],hidden:false};

  // OrderAccordionは外部コンポーネント化（Hooks制約回避）



  return (
    <div style={{minHeight:"100vh",background:"#f8fafc",fontFamily:"sans-serif"}}>
      <div style={{background:"linear-gradient(135deg,#1e293b,#334155)",color:"#fff",padding:"16px 24px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div><div style={{fontWeight:800,fontSize:20}}>⚙️ 管理画面</div><div style={{fontSize:13,opacity:0.7}}>料理選択システム 管理者モード</div></div>
        <Btn size="sm" color="gray" onClick={()=>{setAuthed(false);setOperatorName("");setOperatorInput("");try{sessionStorage.removeItem("ss_operator");}catch{}onBack();}}>ログアウト</Btn>
      </div>
      <div style={{maxWidth:1000,margin:"0 auto",padding:24}}>
        <div style={{display:"flex",gap:4,marginBottom:24,background:"#e2e8f0",padding:4,borderRadius:12,width:"fit-content"}}>
          {[["orders","📊 注文データ"],["categories","🏷️ カテゴリ管理"],["menus","🍽️ メニュー管理"],["site","🖼️ トップページ設定"],["history","📋 変更履歴"]].map(([t,label])=>(
            <button key={t} onClick={()=>setTab(t)} style={{padding:"8px 20px",borderRadius:8,border:"none",cursor:"pointer",fontWeight:600,fontSize:14,background:tab===t?"#fff":"transparent",color:tab===t?"#1e293b":"#64748b",boxShadow:tab===t?"0 1px 4px rgba(0,0,0,0.1)":"none"}}>{label}</button>
          ))}
        </div>

        {tab==="orders" && (
          <div>
            <div style={{background:"#fff",borderRadius:16,padding:24,boxShadow:"0 2px 12px rgba(0,0,0,0.07)",marginBottom:20}}>
              <h3 style={{margin:"0 0 4px",fontSize:18,fontWeight:800}}>📊 注文データ（利用日が未来・当日）</h3>
              <p style={{color:"#64748b",fontSize:13,marginBottom:16}}>利用日の昇順で表示しています</p>
              {activeOrders.length===0 ? <p style={{color:"#94a3b8"}}>該当データはありません</p> : <OrderAccordion orderList={activeOrders} orders={orders} saveOrders={saveOrders} menus={menus} categories={categories} expandedOrder={expandedOrder} setExpandedOrder={setExpandedOrder} expandedCart={expandedCart} setExpandedCart={setExpandedCart} setDeleteOrderTarget={setDeleteOrderTarget}/>}
            </div>
            <div style={{background:"#fff",borderRadius:16,padding:24,boxShadow:"0 2px 12px rgba(0,0,0,0.07)"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,cursor:"pointer"}} onClick={()=>setShowPast(p=>!p)}>
                <h3 style={{margin:0,fontSize:18,fontWeight:800,color:"#94a3b8"}}>🗂️ 過去の注文データ{pastOrders.length>0&&<span style={{fontSize:13,marginLeft:8}}>({pastOrders.length}件)</span>}</h3>
                <span style={{fontSize:20,color:"#94a3b8"}}>{showPast?"▲":"▼"}</span>
              </div>
              {showPast && (
                <>
                  <div style={{marginBottom:16}}>
                    {/* E: プレースホルダーをスラッシュ区切りの例示に */}
                    <input value={pastSearch} onChange={e=>setPastSearch(e.target.value)} placeholder="🔍 予約番号・利用日（例：2025/01/01）・代表者名で検索"
                      style={{width:"100%",padding:"10px 14px",border:"1.5px solid #d1d5db",borderRadius:8,fontSize:14,boxSizing:"border-box"}}/>
                  </div>
                  {filteredPast.length===0 ? <p style={{color:"#94a3b8"}}>該当データはありません</p> : <OrderAccordion orderList={filteredPast} orders={orders} saveOrders={saveOrders} menus={menus} categories={categories} expandedOrder={expandedOrder} setExpandedOrder={setExpandedOrder} expandedCart={expandedCart} setExpandedCart={setExpandedCart} setDeleteOrderTarget={setDeleteOrderTarget}/>}
                </>
              )}
            </div>
          </div>
        )}

        {tab==="categories" && (
          <div style={{background:"#fff",borderRadius:16,padding:24,boxShadow:"0 2px 12px rgba(0,0,0,0.07)"}}>
            <h3 style={{margin:"0 0 4px",fontSize:18,fontWeight:800}}>🏷️ カテゴリ管理</h3>
            <p style={{color:"#64748b",fontSize:13,marginBottom:20}}>全季節共通で適用されます。☰ をドラッグして並び順を変更できます。</p>
            {catDirty && (
              <div style={{background:"#fffbeb",border:"1.5px solid #fcd34d",borderRadius:10,padding:"10px 16px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontSize:14,color:"#92400e",fontWeight:600}}>⚠️ 並び順が変更されています。</span>
                <div style={{display:"flex",gap:8}}>
                  <Btn size="sm" color="success" onClick={handleSaveCatOrder}>💾 並び順を保存</Btn>
                  <Btn size="sm" color="gray" onClick={()=>{setCatDragList(null);setCatDirty(false);}}>リセット</Btn>
                </div>
              </div>
            )}
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:14,marginBottom:24}}>
              <thead><tr style={{background:"#f8fafc"}}>
                <th style={{padding:"10px 8px",borderBottom:"2px solid #e2e8f0",width:32}}></th>
                <th style={{padding:"10px 8px",textAlign:"left",borderBottom:"2px solid #e2e8f0"}}>順番</th>
                <th style={{padding:"10px 8px",textAlign:"left",borderBottom:"2px solid #e2e8f0"}}>カテゴリ名</th>
                <th style={{padding:"10px 8px",textAlign:"left",borderBottom:"2px solid #e2e8f0"}}>操作</th>
              </tr></thead>
              <tbody>
                {sortedCats.map((c,i)=>(
                  <tr key={c.id} draggable onDragStart={()=>onCatDragStart(i)} onDragEnter={()=>onCatDragEnter(i)} onDragEnd={()=>{catDragIdx.current=null;}} onDragOver={e=>e.preventDefault()}
                    style={{borderBottom:"1px solid #f1f5f9"}}>
                    <td style={{padding:"8px",cursor:"grab",color:"#94a3b8",fontSize:18,textAlign:"center",userSelect:"none"}}>☰</td>
                    <td style={{padding:"8px",color:"#94a3b8",fontWeight:600}}>{i+1}</td>
                    <td style={{padding:"8px",fontWeight:700}}>{c.name}</td>
                    <td style={{padding:"8px"}}>
                      <div style={{display:"flex",gap:4}}>
                        <Btn size="sm" onClick={()=>setEditCat({...c})}>編集</Btn>
                        <Btn size="sm" color="danger" onClick={()=>setDeleteCatTarget(c)}>削除</Btn>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{borderTop:"2px solid #f1f5f9",paddingTop:20}}>
              <h4 style={{margin:"0 0 12px",fontWeight:700}}>＋ カテゴリを追加</h4>
              <div style={{display:"flex",gap:8,alignItems:"flex-end"}}>
                <div style={{flex:1}}><Input label="カテゴリ名" value={newCatName} onChange={setNewCatName} placeholder="例：デザート"/></div>
                <Btn color="success" onClick={handleSaveCat} disabled={!newCatName} style={{marginBottom:16}}>追加</Btn>
              </div>
            </div>
          </div>
        )}

        {tab==="site" && (
          <SiteConfigEditor siteConfig={siteConfig} saveSiteConfig={saveSiteConfig}/>
        )}

        {tab==="history" && (
          <div style={{padding:"0 4px"}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,flexWrap:"wrap",gap:8}}>
              <h3 style={{margin:0,fontSize:18,fontWeight:800}}>📋 メニュー変更履歴</h3>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <span style={{fontSize:12,color:"#94a3b8"}}>最新{Math.min((menuHistory||[]).length,200)}件</span>
                {(menuHistory||[]).length>0 && (
                  <Btn size="sm" color="danger" onClick={()=>{ if(window.confirm("履歴をすべて削除しますか？")) saveMenuHistory([]); }}>履歴をクリア</Btn>
                )}
              </div>
            </div>
            {(menuHistory||[]).length===0 ? (
              <div style={{textAlign:"center",padding:"48px 24px",color:"#94a3b8",fontSize:14}}>変更履歴はまだありません</div>
            ) : (
              <>
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  {(menuHistory||[]).slice(historyPage*HISTORY_PER_PAGE,(historyPage+1)*HISTORY_PER_PAGE).map(h=>{
                    const actionColor=h.action==="追加"?"#16a34a":h.action==="削除"?"#dc2626":"#2563eb";
                    const actionBg=h.action==="追加"?"#f0fdf4":h.action==="削除"?"#fef2f2":"#eff6ff";
                    const dt=new Date(h.timestamp);
                    const dtStr=`${dt.getFullYear()}/${String(dt.getMonth()+1).padStart(2,"0")}/${String(dt.getDate()).padStart(2,"0")} ${String(dt.getHours()).padStart(2,"0")}:${String(dt.getMinutes()).padStart(2,"0")}`;
                    return (
                      <div key={h.id} style={{background:"#fff",border:"1px solid #e2e8f0",borderRadius:6,overflow:"hidden"}}>
                        {/* ヘッダー行 */}
                        <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",flexWrap:"wrap"}}>
                          <span style={{background:actionBg,color:actionColor,fontSize:11,fontWeight:700,padding:"2px 10px",borderRadius:20,border:`1px solid ${actionColor}22`}}>{h.action}</span>
                          {(()=>{
                            const season=h.after?.season||h.before?.season||(h.action==="並び替え"?h.before?.season||h.after?.season:null);
                            const th2=SEASON_THEME[season]||null;
                            return season?(
                              <span style={{fontSize:11,fontWeight:600,padding:"2px 8px",borderRadius:4,background:th2?th2.accentLight:"#f1f5f9",color:th2?th2.accent:"#64748b"}}>{th2?th2.motif:""} {season}</span>
                            ):null;
                          })()}
                          <span style={{fontWeight:600,fontSize:13,color:"#1e293b"}}>{h.after?.name||h.before?.name||(h.action==="並び替え"?"並び順変更":"不明")}</span>
                          <span style={{fontSize:11,color:"#64748b",marginLeft:"auto"}}>{dtStr}</span>
                          <span style={{fontSize:11,color:"#2563eb",background:"#eff6ff",padding:"2px 8px",borderRadius:4,fontWeight:600}}>{h.operator||"不明"}</span>
                          <span style={{fontSize:11,color:"#94a3b8",background:"#f1f5f9",padding:"2px 8px",borderRadius:4}}>{h.device}</span>
                        </div>
                        {/* 変更内容 */}
                        {h.action==="並び替え" ? (
                          <div style={{padding:"10px 14px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                            <div>
                              <div style={{fontSize:10,fontWeight:700,color:"#dc2626",marginBottom:6,letterSpacing:1}}>変更前の順番</div>
                              {(h.before?.order||[]).map((name,i)=>(
                                <div key={i} style={{fontSize:11,color:"#475569",padding:"2px 0",display:"flex",gap:6,alignItems:"center"}}>
                                  <span style={{color:"#94a3b8",minWidth:18}}>{i+1}.</span>{name}
                                </div>
                              ))}
                            </div>
                            <div>
                              <div style={{fontSize:10,fontWeight:700,color:"#16a34a",marginBottom:6,letterSpacing:1}}>変更後の順番</div>
                              {(h.after?.order||[]).map((name,i)=>{
                                const moved=(h.before?.order||[])[i]!==name;
                                return (
                                  <div key={i} style={{fontSize:11,color:moved?"#2563eb":"#475569",fontWeight:moved?700:400,padding:"2px 0",display:"flex",gap:6,alignItems:"center"}}>
                                    <span style={{color:"#94a3b8",minWidth:18}}>{i+1}.</span>{name}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                        <div style={{display:"grid",gridTemplateColumns:h.action==="追加"?"1fr":h.action==="削除"?"1fr":"1fr 1fr",gap:0}}>
                          {h.before && (
                            <div style={{padding:"10px 14px",borderRight:h.after?"1px solid #e2e8f0":undefined}}>
                              <div style={{fontSize:10,fontWeight:700,color:"#dc2626",marginBottom:6,letterSpacing:1}}>変更前</div>
                              <table style={{fontSize:11,color:"#475569",borderCollapse:"collapse",width:"100%"}}>
                                {[["料理名",h.before.name],["季節",h.before.season],["ポイント",h.before.points+"pt"],["説明",h.before.desc||"なし"],["写真",h.before.img],["非表示",h.before.hidden?"はい":"いいえ"]].map(([k,v])=>(
                                  <tr key={k}><td style={{padding:"2px 8px 2px 0",color:"#94a3b8",whiteSpace:"nowrap"}}>{k}</td><td style={{padding:"2px 0"}}>{v}</td></tr>
                                ))}
                              </table>
                            </div>
                          )}
                          {h.after && (
                            <div style={{padding:"10px 14px"}}>
                              <div style={{fontSize:10,fontWeight:700,color:"#16a34a",marginBottom:6,letterSpacing:1}}>{h.action==="追加"?"登録内容":"変更後"}</div>
                              <table style={{fontSize:11,color:"#475569",borderCollapse:"collapse",width:"100%"}}>
                                {[["料理名",h.after.name],["季節",h.after.season],["ポイント",h.after.points+"pt"],["説明",h.after.desc||"なし"],["写真",h.after.img],["非表示",h.after.hidden?"はい":"いいえ"]].map(([k,v])=>{
                                  const changed=h.before&&h.before[k==="料理名"?"name":k==="季節"?"season":k==="ポイント"?"points":k==="説明"?"desc":k==="写真"?"img":"hidden"]!==h.after[k==="料理名"?"name":k==="季節"?"season":k==="ポイント"?"points":k==="説明"?"desc":k==="写真"?"img":"hidden"];
                                  return <tr key={k}><td style={{padding:"2px 8px 2px 0",color:"#94a3b8",whiteSpace:"nowrap"}}>{k}</td><td style={{padding:"2px 0",fontWeight:changed&&h.before?"700":"400",color:changed&&h.before?"#2563eb":"#475569"}}>{v}</td></tr>;
                                })}
                              </table>
                            </div>
                          )}
                        </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                {/* ページネーション */}
                {(menuHistory||[]).length>HISTORY_PER_PAGE && (
                  <div style={{display:"flex",gap:8,justifyContent:"center",marginTop:16,alignItems:"center"}}>
                    <Btn size="sm" color="gray" onClick={()=>setHistoryPage(p=>Math.max(0,p-1))} disabled={historyPage===0}>← 前</Btn>
                    <span style={{fontSize:12,color:"#64748b"}}>{historyPage+1} / {Math.ceil((menuHistory||[]).length/HISTORY_PER_PAGE)}</span>
                    <Btn size="sm" color="gray" onClick={()=>setHistoryPage(p=>Math.min(Math.ceil((menuHistory||[]).length/HISTORY_PER_PAGE)-1,p+1))} disabled={(historyPage+1)*HISTORY_PER_PAGE>=(menuHistory||[]).length}>次 →</Btn>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {tab==="menus" && (
          <div style={{background:"#fff",borderRadius:16,padding:24,boxShadow:"0 2px 12px rgba(0,0,0,0.07)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
              <h3 style={{margin:0,fontSize:18,fontWeight:800}}>🍽️ メニュー管理</h3>
              <div style={{display:"flex",gap:8}}>
                <Btn size="sm" color="info" onClick={()=>{
                  const to=SEASON_LIST.find(s=>s!==seasonTab)||"夏";
                  setBulkCopyTo(to);
                  setBulkCopyDates({start:SEASON_DATES[to].start,end:SEASON_DATES[to].end});
                  setBulkCopyModal(true);
                }}>📋 季節一括コピー</Btn>
                <Btn size="sm" color="success" onClick={()=>setNewMenu({...emptyMenu})}>＋ 新規追加</Btn>
              </div>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:16,marginBottom:20,flexWrap:"wrap"}}>
              <div style={{display:"flex",gap:4,background:"#f1f5f9",padding:4,borderRadius:12}}>
                {SEASON_LIST.map(s=>(
                  <button key={s} onClick={()=>setSeasonTab(s)} style={{padding:"7px 20px",borderRadius:8,border:"none",cursor:"pointer",fontWeight:700,fontSize:14,background:seasonTab===s?SEASON_COLOR[s]:"transparent",color:seasonTab===s?"#1e293b":"#64748b",transition:"all 0.15s"}}>{SEASON_EMOJI[s]} {s}</button>
                ))}
              </div>
              {/* 公開/準備中 トグルボタン */}
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:13,color:"#64748b",fontWeight:500}}>{seasonTab}メニュー：</span>
                <button
                  onClick={()=>{
                    const next={...seasonStatus,[seasonTab]:seasonStatus[seasonTab]==="open"?"preparing":"open"};
                    saveSeasonStatus(next);
                  }}
                  style={{
                    display:"flex",alignItems:"center",gap:6,
                    padding:"6px 16px",borderRadius:20,border:"none",cursor:"pointer",
                    fontWeight:700,fontSize:13,transition:"all 0.2s",
                    background:seasonStatus[seasonTab]==="open"?"#dcfce7":"#fef9c3",
                    color:seasonStatus[seasonTab]==="open"?"#16a34a":"#92400e",
                    boxShadow:"0 1px 4px rgba(0,0,0,0.1)"
                  }}>
                  <span style={{
                    width:8,height:8,borderRadius:"50%",flexShrink:0,
                    background:seasonStatus[seasonTab]==="open"?"#16a34a":"#f59e0b",
                    boxShadow:seasonStatus[seasonTab]==="open"?"0 0 0 2px #bbf7d0":"0 0 0 2px #fde68a"
                  }}/>
                  {seasonStatus[seasonTab]==="open"?"公開中":"準備中"}
                  <span style={{fontSize:11,fontWeight:400,opacity:0.7}}>（クリックで切替）</span>
                </button>
              </div>
            </div>
            {menuDirty && (
              <div style={{background:"#fffbeb",border:"1.5px solid #fcd34d",borderRadius:10,padding:"10px 16px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontSize:14,color:"#92400e",fontWeight:600}}>⚠️ 並び順が変更されています。保存してください。</span>
                <div style={{display:"flex",gap:8}}>
                  <Btn size="sm" color="success" onClick={handleSaveMenuOrder}>💾 並び順を保存</Btn>
                  <Btn size="sm" color="gray" onClick={()=>{setMenuDragList(null);setMenuDirty(false);}}>リセット</Btn>
                </div>
              </div>
            )}
            <p style={{fontSize:13,color:"#94a3b8",marginBottom:12}}>☰ をドラッグしてカテゴリ間を含めた並び順を変更できます</p>
            {displayCats.map(cat=>{
              const groupItems=getGroupMenus(cat.id);
              if(groupItems.length===0 && cat.id===null) return null;
              return (
                <div key={cat.id||"uncat"} style={{marginBottom:20}}>
                  <div style={{fontWeight:700,fontSize:14,color:"#475569",padding:"6px 8px",background:"#f8fafc",borderRadius:"8px 8px 0 0",border:"1px solid #e2e8f0",borderBottom:"none"}}>
                    {cat.name} <span style={{fontSize:12,color:"#94a3b8",fontWeight:400}}>（{groupItems.length}品）</span>
                  </div>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,border:"1px solid #e2e8f0",borderTop:"none"}}>
                    <thead><tr style={{background:"#fafafa"}}>
                      <th style={{padding:"8px",borderBottom:"1px solid #e2e8f0",width:32}}></th>
                      <th style={{padding:"8px",textAlign:"left",borderBottom:"1px solid #e2e8f0"}}>No.</th>
                      <th style={{padding:"8px",textAlign:"left",borderBottom:"1px solid #e2e8f0"}}>メニュー名</th>
                      <th style={{padding:"8px",textAlign:"left",borderBottom:"1px solid #e2e8f0"}}>ポイント</th>
                      <th style={{padding:"8px",textAlign:"left",borderBottom:"1px solid #e2e8f0"}}>アレルゲン</th>
                      <th style={{padding:"8px",textAlign:"left",borderBottom:"1px solid #e2e8f0"}}>期間</th>
                      <th style={{padding:"8px",textAlign:"left",borderBottom:"1px solid #e2e8f0"}}>操作</th>
                    </tr></thead>
                    <tbody>
                      {groupItems.length===0 ? (
                        <tr>
                          <td colSpan={7} onDragOver={onMenuDragOver} onDrop={e=>onMenuDrop(e,null,cat.id)}
                            style={{padding:"24px",textAlign:"center",color:"#94a3b8",fontSize:13,background:"#fafafa"}}>
                            ここにドラッグしてメニューを追加
                          </td>
                        </tr>
                      ) : groupItems.map(m=>(
                        <tr key={m.id} draggable
                          onDragStart={()=>onMenuDragStart(m.id)}
                          onDragOver={onMenuDragOver}
                          onDrop={e=>onMenuDrop(e,m.id,cat.id)}
                          style={{borderBottom:"1px solid #f1f5f9",background:"#fff",cursor:"grab"}}>
                          <td style={{padding:"8px",color:"#94a3b8",fontSize:18,textAlign:"center",userSelect:"none"}}>☰</td>
                          <td style={{padding:"8px",color:"#94a3b8",fontWeight:600}}>{m.no}</td>
                          <td style={{padding:"8px",fontWeight:600}}>
                            <div style={{display:"flex",alignItems:"center",gap:8}}>
                              {m.img
                                ? <img src={m.img} alt="" style={{width:36,height:28,objectFit:"cover",borderRadius:4,border:"1px solid #e2e8f0",flexShrink:0}}/>
                                : <div style={{width:36,height:28,background:"#f1f5f9",borderRadius:4,border:"1px solid #e2e8f0",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12}}>🍽️</div>
                              }
                              <div>
                                <div>{m.name}</div>
                                {/* H: 特記事項を小さく表示 */}
                                {m.note&&<div style={{fontSize:10,color:"#64748b",marginTop:1}}>{m.note}</div>}
                              </div>
                            </div>
                          </td>
                          <td style={{padding:"8px",color:"#2563eb",fontWeight:700}}>{m.points}pt</td>
                          <td style={{padding:"8px",color:"#92400e",fontSize:12}}>{m.allergens||"-"}</td>
                          <td style={{padding:"8px",fontSize:12,color:"#64748b"}}>{m.start}〜{m.end}</td>
                          <td style={{padding:"8px"}}>
                            <div style={{display:"flex",gap:4,alignItems:"center",flexWrap:"wrap"}}>
                              {/* 表示/非表示スイッチ */}
                              <button
                                title={m.hidden?"非表示（クリックで表示に）":"表示中（クリックで非表示に）"}
                                onClick={()=>{
                                  const updated=menus.map(x=>String(x.id)===String(m.id)?{...x,hidden:!x.hidden}:x);
                                  addHistory(m.hidden?"表示に変更":"非表示に変更", m, {...m,hidden:!m.hidden});
                                  saveMenus(updated);
                                }}
                                style={{
                                  padding:"4px 10px",border:"none",borderRadius:20,cursor:"pointer",
                                  fontSize:11,fontWeight:700,letterSpacing:0.3,
                                  background:m.hidden?"#fee2e2":"#dcfce7",
                                  color:m.hidden?"#dc2626":"#16a34a",
                                  transition:"all 0.15s",whiteSpace:"nowrap"
                                }}>
                                {m.hidden?"非表示":"表示中"}
                              </button>
                              <Btn size="sm" onClick={()=>setEditMenu({...m})}>編集</Btn>
                              <Btn size="sm" color="danger" onClick={()=>setDeleteTarget({id:m.id,name:m.name})}>削除</Btn>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {(editMenu||newMenu) && <MenuEditModal menu={editMenu||newMenu} onSave={handleSaveMenu} menus={menus} saveMenus={saveMenus} onClose={()=>{setEditMenu(null);setNewMenu(null);}}/>}
      {bulkCopyModal && (
        <Modal title={"📋 "+seasonTab+"メニューを一括コピー"} onClose={()=>setBulkCopyModal(false)}>
          <div style={{marginBottom:16}}>
            <label style={{display:"block",fontWeight:600,marginBottom:8,color:"#374151"}}>コピー元</label>
            <div style={{padding:"10px 14px",background:"#f8fafc",borderRadius:8,fontSize:14,color:"#64748b"}}>
              {SEASON_EMOJI[seasonTab]} {seasonTab}（{menus.filter(m=>m.season===seasonTab).length}件）
            </div>
          </div>
          <div style={{marginBottom:16}}>
            <label style={{display:"block",fontWeight:600,marginBottom:8,color:"#374151"}}>コピー先の季節</label>
            <div style={{display:"flex",gap:6}}>
              {SEASON_LIST.filter(s=>s!==seasonTab).map(s=>(
                <button key={s} onClick={()=>{
                  setBulkCopyTo(s);
                  setBulkCopyDates({start:SEASON_DATES[s].start,end:SEASON_DATES[s].end});
                }} style={{flex:1,padding:"8px 0",border:"2px solid",borderColor:bulkCopyTo===s?"#2563eb":"#e2e8f0",borderRadius:8,background:bulkCopyTo===s?SEASON_COLOR[s]:"#fff",fontWeight:700,cursor:"pointer",fontSize:13}}>
                  {SEASON_EMOJI[s]}{s}
                </button>
              ))}
            </div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px",marginBottom:20}}>
            <div>
              <label style={{display:"block",fontWeight:600,marginBottom:6,color:"#374151",fontSize:13}}>利用開始日</label>
              <input value={bulkCopyDates.start} onChange={e=>setBulkCopyDates(p=>({...p,start:e.target.value}))}
                placeholder="例：6/1"
                style={{width:"100%",padding:"10px 14px",border:"1.5px solid #d1d5db",borderRadius:8,fontSize:14,boxSizing:"border-box",outline:"none"}}/>
            </div>
            <div>
              <label style={{display:"block",fontWeight:600,marginBottom:6,color:"#374151",fontSize:13}}>利用終了日</label>
              <input value={bulkCopyDates.end} onChange={e=>setBulkCopyDates(p=>({...p,end:e.target.value}))}
                placeholder="例：8/31"
                style={{width:"100%",padding:"10px 14px",border:"1.5px solid #d1d5db",borderRadius:8,fontSize:14,boxSizing:"border-box",outline:"none"}}/>
            </div>
          </div>
          <div style={{background:"#fffbeb",border:"1px solid #fcd34d",borderRadius:8,padding:"10px 14px",marginBottom:16,fontSize:12,color:"#92400e"}}>
            ⚠ {seasonTab}の全{menus.filter(m=>m.season===seasonTab).length}件を{bulkCopyTo}にコピーします。既存の{bulkCopyTo}メニューは残ります。
          </div>
          <div style={{display:"flex",gap:10}}>
            <Btn color="success" onClick={handleBulkCopy} disabled={menus.filter(m=>m.season===seasonTab).length===0} style={{flex:1}}>
              コピーを実行
            </Btn>
            <Btn color="gray" onClick={()=>setBulkCopyModal(false)} style={{flex:1}}>キャンセル</Btn>
          </div>
        </Modal>
      )}}

      {deleteTarget && (
        <Modal title="削除の確認" onClose={()=>setDeleteTarget(null)}>
          <p style={{marginBottom:24,color:"#374151"}}>「<strong>{deleteTarget.name}</strong>」を削除しますか？この操作は元に戻せません。</p>
          <div style={{display:"flex",gap:10}}>
            <Btn color="danger" onClick={()=>handleDeleteMenu(deleteTarget.id)} style={{flex:1}}>削除する</Btn>
            <Btn color="gray" onClick={()=>setDeleteTarget(null)} style={{flex:1}}>キャンセル</Btn>
          </div>
        </Modal>
      )}

      {editCat && (
        <Modal title="カテゴリを編集" onClose={()=>setEditCat(null)}>
          <Input label="カテゴリ名" value={editCat.name} onChange={v=>setEditCat(p=>({...p,name:v}))}/>
          <div style={{display:"flex",gap:10}}>
            <Btn onClick={()=>{saveCategories(categories.map(c=>c.id===editCat.id?{...c,name:editCat.name}:c));setEditCat(null);}} disabled={!editCat.name} style={{flex:1}} color="success">保存</Btn>
            <Btn color="gray" onClick={()=>setEditCat(null)} style={{flex:1}}>キャンセル</Btn>
          </div>
        </Modal>
      )}

      {deleteCatTarget && (
        <Modal title="カテゴリ削除の確認" onClose={()=>setDeleteCatTarget(null)}>
          <p style={{marginBottom:8,color:"#374151"}}>「<strong>{deleteCatTarget.name}</strong>」を削除しますか？</p>
          <p style={{marginBottom:24,fontSize:13,color:"#dc2626"}}>このカテゴリのメニューは「未分類」に移動されます。</p>
          <div style={{display:"flex",gap:10}}>
            <Btn color="danger" onClick={()=>handleDeleteCat(deleteCatTarget.id)} style={{flex:1}}>削除する</Btn>
            <Btn color="gray" onClick={()=>setDeleteCatTarget(null)} style={{flex:1}}>キャンセル</Btn>
          </div>
        </Modal>
      )}

      {deleteOrderTarget && (
        <Modal title="注文データ削除の確認" onClose={()=>setDeleteOrderTarget(null)}>
          <div style={{background:"#fef2f2",border:"1.5px solid #fca5a5",borderRadius:10,padding:"12px 16px",marginBottom:20}}>
            <div style={{fontWeight:700,color:"#dc2626",marginBottom:6}}>⚠️ この操作は元に戻せません</div>
            <div style={{fontSize:14,color:"#374151"}}>以下の注文データを完全に削除します。</div>
          </div>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:14,marginBottom:24,background:"#f8fafc",borderRadius:8,overflow:"hidden"}}>
            <tbody>
              {[["予約番号",deleteOrderTarget.reservationNo],["利用日",fmtDate(deleteOrderTarget.date)],["代表者",deleteOrderTarget.representative],["カート数",`${deleteOrderTarget.carts.length}名分`]].map(([k,v])=>(
                <tr key={k} style={{borderBottom:"1px solid #e2e8f0"}}>
                  <td style={{padding:"8px 12px",fontWeight:600,color:"#64748b",width:"40%"}}>{k}</td>
                  <td style={{padding:"8px 12px",fontWeight:700}}>{v}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{display:"flex",gap:10}}>
            <Btn color="danger" onClick={()=>handleDeleteOrder(deleteOrderTarget.reservationNo)} style={{flex:1}}>削除する</Btn>
            <Btn color="gray" onClick={()=>setDeleteOrderTarget(null)} style={{flex:1}}>キャンセル</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ─── トップページ設定エディタ ────────────────────────────────────────────────
function SiteConfigEditor({siteConfig,saveSiteConfig}){
  const [cfg,setCfg]=useState({...siteConfig});
  const [saved,setSaved]=useState(false);
  const [slideDragging,setSlideDragging]=useState(false);
  const slideFileRef=useRef(null);

  function set(k,v){ setCfg(p=>({...p,[k]:v})); setSaved(false); }

  async function uploadSlideToCloudinary(file){
    if(!file.type.startsWith("image/")) return null;
    const fd=new FormData();
    fd.append("file",file);
    fd.append("upload_preset",CLOUDINARY_UPLOAD_PRESET);
    fd.append("folder","menu-system/slides");
    const res=await fetch(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`,{method:"POST",body:fd});
    const data=await res.json();
    return data.secure_url||null;
  }
  async function processSlideFiles(files){
    const arr=Array.from(files).filter(f=>f.type.startsWith("image/"));
    if(arr.length===0) return;
    setSlideDragging(false);
    // アップロード中表示
    setCfg(p=>({...p,_uploading:(p._uploading||0)+arr.length}));
    for(const file of arr){
      try{
        const url=await uploadSlideToCloudinary(file);
        if(url){
          setCfg(p=>({...p,slides:[...(p.slides||[]),url],_uploading:Math.max(0,(p._uploading||1)-1)}));
          setSaved(false);
        } else {
          setCfg(p=>({...p,_uploading:Math.max(0,(p._uploading||1)-1)}));
        }
      }catch{
        setCfg(p=>({...p,_uploading:Math.max(0,(p._uploading||1)-1)}));
      }
    }
  }
  function addSlideFile(e){ processSlideFiles(e.target.files); e.target.value=""; }
  function handleSlideDrop(e){
    e.preventDefault(); setSlideDragging(false);
    processSlideFiles(e.dataTransfer.files);
  }
  function removeSlide(i){
    setCfg(p=>({...p,slides:p.slides.filter((_,idx)=>idx!==i)}));
    setSaved(false);
  }
  function moveSlide(i,dir){
    const slides=[...cfg.slides];
    const j=i+dir;
    if(j<0||j>=slides.length) return;
    [slides[i],slides[j]]=[slides[j],slides[i]];
    setCfg(p=>({...p,slides}));
    setSaved(false);
  }
  async function handleSave(){
    await saveSiteConfig(cfg);
    setSaved(true);
    setTimeout(()=>setSaved(false),2000);
  }

  return (
    <div style={{background:"#fff",borderRadius:16,padding:24,boxShadow:"0 2px 12px rgba(0,0,0,0.07)"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
        <h3 style={{margin:0,fontSize:18,fontWeight:800}}>🖼️ トップページ設定</h3>
        <button onClick={handleSave}
          style={{padding:"8px 24px",background:saved?"#16a34a":"#1e293b",color:"#fff",border:"none",borderRadius:8,fontWeight:700,cursor:"pointer",fontSize:14,transition:"background 0.2s"}}>
          {saved?"✓ 保存済み":"保存する"}
        </button>
      </div>

      {/* ロゴ */}
      <div style={{marginBottom:24,paddingBottom:24,borderBottom:"1px solid #f1f5f9"}}>
        <label style={{display:"block",fontWeight:700,marginBottom:4,fontSize:14,color:"#374151"}}>ロゴ画像</label>
        <p style={{fontSize:12,color:"#94a3b8",marginBottom:10}}>未設定の場合は🍽️アイコンを表示</p>
        <ImageUploader label={false} value={cfg.logoUrl||""} onChange={v=>set("logoUrl",v)}/>
      </div>

      {/* ファビコン */}
      <div style={{marginBottom:24,paddingBottom:24,borderBottom:"1px solid #f1f5f9"}}>
        <label style={{display:"block",fontWeight:700,marginBottom:4,fontSize:14,color:"#374151"}}>ファビコン</label>
        <p style={{fontSize:12,color:"#94a3b8",marginBottom:10}}>ブラウザのタブに表示されるアイコンです。正方形の画像（推奨：64×64px以上）</p>
        <ImageUploader label={false} value={cfg.faviconUrl||""} onChange={v=>set("faviconUrl",v)}/>
        {cfg.faviconUrl && (
          <div style={{display:"flex",alignItems:"center",gap:8,marginTop:4}}>
            <img src={cfg.faviconUrl} alt="favicon preview" style={{width:20,height:20,objectFit:"contain",borderRadius:2}}/>
            <span style={{fontSize:11,color:"#94a3b8"}}>タブでの表示イメージ</span>
          </div>
        )}
      </div>

      {/* タイトル */}
      <div style={{marginBottom:20}}>
        <label style={{display:"block",fontWeight:700,marginBottom:6,fontSize:14,color:"#374151"}}>タイトル</label>
        <input value={cfg.title||""} onChange={e=>set("title",e.target.value)}
          placeholder="料理選択システム"
          style={{width:"100%",padding:"10px 14px",border:"1.5px solid #d1d5db",borderRadius:8,fontSize:14,boxSizing:"border-box",outline:"none"}}/>
      </div>

      {/* サブタイトル */}
      <div style={{marginBottom:24,paddingBottom:24,borderBottom:"1px solid #f1f5f9"}}>
        <label style={{display:"block",fontWeight:700,marginBottom:6,fontSize:14,color:"#374151"}}>サブタイトル</label>
        <input value={cfg.subtitle||""} onChange={e=>set("subtitle",e.target.value)}
          placeholder="旬の食材を活かした季節の膳"
          style={{width:"100%",padding:"10px 14px",border:"1.5px solid #d1d5db",borderRadius:8,fontSize:14,boxSizing:"border-box",outline:"none"}}/>
      </div>

      {/* スライド写真 */}
      <div>
        <label style={{display:"block",fontWeight:700,marginBottom:4,fontSize:14,color:"#374151"}}>スライド写真</label>
        <p style={{fontSize:12,color:"#94a3b8",marginBottom:12}}>複数登録すると4秒ごとに自動スライドします。</p>

        {/* アップロードエリア（クリック＆D&D対応） */}
        <div
          onClick={()=>{ if(!cfg._uploading) slideFileRef.current?.click(); }}
          onDrop={handleSlideDrop}
          onDragOver={e=>{ e.preventDefault(); setSlideDragging(true); }}
          onDragLeave={()=>setSlideDragging(false)}
          style={{border:"1px dashed "+(slideDragging?"#7a3d1a":"#c8b89a"),borderRadius:8,padding:"16px",textAlign:"center",cursor:cfg._uploading?"not-allowed":"pointer",background:slideDragging?"#fdf0e4":cfg._uploading?"#f5f0ea":"#fdf9f5",marginBottom:16,transition:"all 0.15s"}}>
          {cfg._uploading ? (
            <>
              <div style={{fontSize:22,marginBottom:4}}>⏳</div>
              <div style={{fontSize:13,color:"#7a3d1a"}}>アップロード中... ({cfg._uploading}枚)</div>
            </>
          ) : (
            <>
              <div style={{fontSize:24,marginBottom:4}}>{slideDragging?"📂":"📷"}</div>
              <div style={{fontSize:13,color:"#8a7060"}}>クリックまたはドラッグ＆ドロップ（複数可）</div>
              <div style={{fontSize:11,color:"#b0a090",marginTop:2}}>JPG / PNG / WebP</div>
            </>
          )}
        </div>
        <input ref={slideFileRef} type="file" accept="image/*" multiple onChange={addSlideFile} style={{display:"none"}}/>

        {/* 登録済み一覧 */}
        {(cfg.slides||[]).length===0 ? (
          <p style={{color:"#94a3b8",fontSize:13}}>スライド未登録</p>
        ) : (
          <div>
            {cfg.slides.map((src,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",border:"1px solid #e2e8f0",borderRadius:8,marginBottom:6,background:"#f8fafc"}}>
                <img src={src} alt="" style={{width:64,height:40,objectFit:"cover",borderRadius:4,flexShrink:0,background:"#e2e8f0"}}/>
                <span style={{flex:1,fontSize:11,color:"#94a3b8"}}>{i+1}枚目</span>
                <button onClick={()=>moveSlide(i,-1)} disabled={i===0}
                  style={{padding:"3px 8px",border:"1px solid #e2e8f0",borderRadius:4,background:"#fff",cursor:i===0?"not-allowed":"pointer",color:"#64748b",fontSize:12,opacity:i===0?0.4:1}}>↑</button>
                <button onClick={()=>moveSlide(i,1)} disabled={i===(cfg.slides.length-1)}
                  style={{padding:"3px 8px",border:"1px solid #e2e8f0",borderRadius:4,background:"#fff",cursor:i===(cfg.slides.length-1)?"not-allowed":"pointer",color:"#64748b",fontSize:12,opacity:i===(cfg.slides.length-1)?0.4:1}}>↓</button>
                <button onClick={()=>removeSlide(i)}
                  style={{padding:"3px 10px",border:"1px solid #fca5a5",borderRadius:4,background:"#fef2f2",cursor:"pointer",color:"#dc2626",fontSize:12,fontWeight:700}}>✕</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// H: 特記事項フィールドを追加したMenuEditModal
function MenuEditModal({menu,onSave,menus,saveMenus,onClose}){
  const [m,setM]=useState({...menu, note: menu.note||"", hidden: !!menu.hidden});
  const [showCopy,setShowCopy]=useState(false);
  const [copySeason,setCopySeason]=useState(SEASON_LIST.find(s=>s!==menu.season)||"夏");
  const [copyDates,setCopyDates]=useState({
    start:SEASON_DATES[SEASON_LIST.find(s=>s!==menu.season)||"夏"].start,
    end:SEASON_DATES[SEASON_LIST.find(s=>s!==menu.season)||"夏"].end
  });

  function set(k,v){setM(p=>({...p,[k]:v}));}
  function handleSeasonChange(s){setM(p=>({...p,season:s,...SEASON_DATES[s]}));}
  function handleCopySeasonChange(s){
    setCopySeason(s);
    setCopyDates({start:SEASON_DATES[s].start,end:SEASON_DATES[s].end});
  }
  async function handleCopySave(){
    if(!menus||!saveMenus) return;
    const copy={
      ...m,
      id:Date.now(),
      season:copySeason,
      start:copyDates.start,
      end:copyDates.end,
      order:(menus.filter(x=>x.season===copySeason).length+1),
    };
    await saveMenus(withNos([...menus,copy]));
    alert(copySeason+"にコピーしました");
    setShowCopy(false);
  }

  return (
    <Modal title={m.id?"メニューを編集":"メニューを追加"} onClose={onClose}>
      <div style={{marginBottom:16}}>
        <label style={{display:"block",fontWeight:600,marginBottom:6,color:"#374151"}}>季節</label>
        <div style={{display:"flex",gap:6}}>
          {SEASON_LIST.map(s=>(
            <button key={s} onClick={()=>handleSeasonChange(s)} style={{flex:1,padding:"8px 0",border:"2px solid",borderColor:m.season===s?"#2563eb":"#e2e8f0",borderRadius:8,background:m.season===s?SEASON_COLOR[s]:"#fff",fontWeight:700,cursor:"pointer",fontSize:13}}>{SEASON_EMOJI[s]}{s}</button>
          ))}
        </div>
      </div>
      <Input label="メニュー名" value={m.name} onChange={v=>set("name",v)} placeholder="料理名を入力"/>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
        <Input label="ポイント" value={m.points} onChange={v=>set("points",Number(v))} type="number"/>
        <Input label="アレルゲン" value={m.allergens} onChange={v=>set("allergens",v)} placeholder="例：小麦・卵"/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
        <Input label="利用開始日" value={m.start} onChange={v=>set("start",v)} placeholder="例：3/1"/>
        <Input label="利用終了日" value={m.end} onChange={v=>set("end",v)} placeholder="例：5/31"/>
      </div>
      <ImageUploader value={m.img} onChange={v=>set("img",v)}/>
      {/* 特記事項欄 */}
      <div style={{marginBottom:16}}>
        <label style={{display:"block",fontWeight:600,marginBottom:6,color:"#374151"}}>特記事項 <span style={{fontSize:11,color:"#94a3b8",fontWeight:400}}>（任意・メニューカードに小さく表示）</span></label>
        <textarea
          value={m.note}
          onChange={e=>set("note",e.target.value)}
          placeholder="例：数量限定・温かい状態でご提供します　など"
          rows={3}
          style={{width:"100%",padding:"10px 14px",border:"1.5px solid #d1d5db",borderRadius:8,fontSize:12,boxSizing:"border-box",outline:"none",resize:"vertical",color:"#374151",lineHeight:1.5}}
        />
      </div>

      {/* 個別コピー */}
      {m.id && (
        <div style={{marginBottom:16}}>
          <button onClick={()=>setShowCopy(v=>!v)}
            style={{width:"100%",padding:"9px",background:"#f0f9ff",border:"1.5px solid #bae6fd",borderRadius:8,color:"#0369a1",fontWeight:600,fontSize:13,cursor:"pointer",textAlign:"left",display:"flex",alignItems:"center",gap:6}}>
            <span>📋 別の季節にコピー</span>
            <span style={{marginLeft:"auto",fontSize:12}}>{showCopy?"▲":"▼"}</span>
          </button>
          {showCopy && (
            <div style={{border:"1.5px solid #bae6fd",borderTop:"none",borderRadius:"0 0 8px 8px",padding:14,background:"#f0f9ff"}}>
              <label style={{display:"block",fontWeight:600,marginBottom:8,fontSize:13,color:"#374151"}}>コピー先の季節</label>
              <div style={{display:"flex",gap:6,marginBottom:12}}>
                {SEASON_LIST.filter(s=>s!==m.season).map(s=>(
                  <button key={s} onClick={()=>handleCopySeasonChange(s)}
                    style={{flex:1,padding:"7px 0",border:"2px solid",borderColor:copySeason===s?"#2563eb":"#e2e8f0",borderRadius:8,background:copySeason===s?SEASON_COLOR[s]:"#fff",fontWeight:700,cursor:"pointer",fontSize:12}}>
                    {SEASON_EMOJI[s]}{s}
                  </button>
                ))}
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 12px",marginBottom:12}}>
                <div>
                  <label style={{display:"block",fontSize:12,fontWeight:600,color:"#374151",marginBottom:4}}>利用開始日</label>
                  <input value={copyDates.start} onChange={e=>setCopyDates(p=>({...p,start:e.target.value}))}
                    placeholder="例：6/1"
                    style={{width:"100%",padding:"8px 12px",border:"1.5px solid #d1d5db",borderRadius:8,fontSize:13,boxSizing:"border-box",outline:"none"}}/>
                </div>
                <div>
                  <label style={{display:"block",fontSize:12,fontWeight:600,color:"#374151",marginBottom:4}}>利用終了日</label>
                  <input value={copyDates.end} onChange={e=>setCopyDates(p=>({...p,end:e.target.value}))}
                    placeholder="例：8/31"
                    style={{width:"100%",padding:"8px 12px",border:"1.5px solid #d1d5db",borderRadius:8,fontSize:13,boxSizing:"border-box",outline:"none"}}/>
                </div>
              </div>
              <Btn color="info" onClick={handleCopySave} style={{width:"100%"}}>
                {copySeason}にコピーして保存
              </Btn>
            </div>
          )}
        </div>
      )}

      <div style={{display:"flex",gap:10,marginTop:8}}>
        <Btn onClick={()=>onSave(m)} disabled={!m.name} style={{flex:1}} color="success">保存</Btn>
        <Btn color="gray" onClick={onClose} style={{flex:1}}>キャンセル</Btn>
      </div>
    </Modal>
  );
}

export default App;
